import React__default, { useContext, createContext, useReducer, createElement, Fragment, useState, useEffect, memo } from 'react';
import produce from 'immer';
import 'decimal.js';
import _partition from 'lodash-es/partition';
import Drawer from '@material-ui/core/Drawer';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import styled from '@emotion/styled';
import { styles, MuiButton, MuiInput } from '@onehope/design-system-ohw';
import { jsx, css } from '@emotion/core';
import { withStyles, useTheme } from '@material-ui/core/styles';
import MuiTextField from '@material-ui/core/TextField';
import isNumeric from 'validator/lib/isNumeric';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import CheckCircleIcon$1 from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import MuiDialog from '@material-ui/core/Dialog';
import MuiIconButton from '@material-ui/core/IconButton';
import CloseIcon$1 from '@material-ui/icons/Close';
import MuiSelect from '@material-ui/core/Select';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { Formik, Form } from 'formik';
import Button$3 from '@material-ui/core/Button';
import { object, string } from 'yup';
import CancelIcon from '@material-ui/icons/Cancel';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon$1 from '@material-ui/icons/Remove';
import { Discount } from '@onehope/customer-rewards';

var CartNetworkLayerContext = /*#__PURE__*/createContext();
var useCartNetworkLayerValue = function useCartNetworkLayerValue() {
  return useContext(CartNetworkLayerContext);
};
function CartNetworkLayer(_ref) {
  var children = _ref.children,
      flags = _ref.flags,
      user = _ref.user,
      pwpConfig = _ref.pwpConfig,
      assetsUrl = _ref.assetsUrl,
      cartOpen = _ref.cartOpen,
      handleGoToProductDetailsPage = _ref.handleGoToProductDetailsPage,
      productsBulk = _ref.productsBulk,
      showPwpDialog = _ref.showPwpDialog,
      toggleCartOpen = _ref.toggleCartOpen,
      toggleCartClosed = _ref.toggleCartClosed,
      togglePwpDialogClosed = _ref.togglePwpDialogClosed,
      handleGoToCheckout = _ref.handleGoToCheckout,
      handleAddMoreItems = _ref.handleAddMoreItems,
      hopeCommerceUrl = _ref.hopeCommerceUrl,
      checkoutUrl = _ref.checkoutUrl,
      handleCartAdd = _ref.handleCartAdd,
      handleCartDelete = _ref.handleCartDelete,
      handleGoToPreferred = _ref.handleGoToPreferred,
      handleCartAutoshipToggle = _ref.handleCartAutoshipToggle,
      handleAutoshipCount = _ref.handleAutoshipCount,
      handleTogglePcMembership = _ref.handleTogglePcMembership,
      handlePromoCodeUpdate = _ref.handlePromoCodeUpdate,
      handlePromoCodeDelete = _ref.handlePromoCodeDelete,
      handleApplyRewards = _ref.handleApplyRewards,
      cartMutationLoading = _ref.cartMutationLoading,
      cartPromoCodeUpdateMutationLoading = _ref.cartPromoCodeUpdateMutationLoading,
      applyRewardsToCartMutationLoading = _ref.applyRewardsToCartMutationLoading,
      seasonalWineClubDateGate = _ref.seasonalWineClubDateGate;
  return React__default.createElement(CartNetworkLayerContext.Provider, {
    value: {
      flags: flags,
      user: user,
      pwpConfig: pwpConfig,
      productsBulk: productsBulk,
      assetsUrl: assetsUrl,
      cartOpen: cartOpen,
      handleGoToProductDetailsPage: handleGoToProductDetailsPage,
      toggleCartOpen: toggleCartOpen,
      toggleCartClosed: toggleCartClosed,
      handleGoToPreferred: handleGoToPreferred,
      handleGoToCheckout: handleGoToCheckout,
      handleAddMoreItems: handleAddMoreItems,
      hopeCommerceUrl: hopeCommerceUrl,
      checkoutUrl: checkoutUrl,
      handleCartAdd: handleCartAdd,
      showPwpDialog: showPwpDialog,
      handleCartDelete: handleCartDelete,
      handleAutoshipCount: handleAutoshipCount,
      cartMutationLoading: cartMutationLoading,
      handlePromoCodeUpdate: handlePromoCodeUpdate,
      handlePromoCodeDelete: handlePromoCodeDelete,
      handleApplyRewards: handleApplyRewards,
      togglePwpDialogClosed: togglePwpDialogClosed,
      handleTogglePcMembership: handleTogglePcMembership,
      handleCartAutoshipToggle: handleCartAutoshipToggle,
      cartPromoCodeUpdateMutationLoading: cartPromoCodeUpdateMutationLoading,
      applyRewardsToCartMutationLoading: applyRewardsToCartMutationLoading,
      seasonalWineClubDateGate: seasonalWineClubDateGate
    }
  }, children);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var TypeKeys;

(function (TypeKeys) {
  TypeKeys["UPDATE_CART"] = "UPDATE_CART";
  TypeKeys["UPDATE_CART_ITEMS"] = "UPDATE_CART_ITEMS";
  TypeKeys["DELETE_CART_ITEM"] = "DELETE_CART_ITEM";
  TypeKeys["UPDATE_DISCOUNTED_CART_ITEMS"] = "UPDATE_DISCOUNTED_CART_ITEMS";
  TypeKeys["UPDATE_CART_TOTAL_NUMBER_OF_ITEMS"] = "UPDATE_CART_TOTAL_NUMBER_OF_ITEMS";
  TypeKeys["UPDATE_AUTOSHIP_ENABLED"] = "UPDATE_AUTOSHIP_ENABLED";
  TypeKeys["UPDATE_AUTOSHIP_AT_TOP"] = "UPDATE_AUTOSHIP_AT_TOP";
  TypeKeys["UPDATE_AUTOSHIP_COUNT"] = "UPDATE_AUTOSHIP_COUNT";
  TypeKeys["UPDATE_ENROLLING_AS_PC"] = "UPDATE_ENROLLING_AS_PC";
  TypeKeys["UPDATE_IS_USER_A_PC"] = "UPDATE_IS_USER_A_PC";
  TypeKeys["UPDATE_CART_VIA_QUALIFIED_TOTAL"] = "UPDATE_CART_VIA_QUALIFIED_TOTAL";
  TypeKeys["UPDATE_HAS_GATED_ITEM_IN_CART"] = "UPDATE_HAS_GATED_ITEM_IN_CART";
  TypeKeys["UPDATE_PC_SALE_SUBSCRIPTION_DIALOG"] = "UPDATE_PC_SALE_SUBSCRIPTION_DIALOG";
  TypeKeys["UPDATE_DISPLAY_PWP_DIALOG"] = "UPDATE_DISPLAY_PWP_DIALOG";
})(TypeKeys || (TypeKeys = {}));

function reducer(state, action) {
  return produce(state, function (draft) {
    switch (action.type) {
      case TypeKeys.UPDATE_CART:
        var updatedCart = action.updatedCart;
        draft.cart = updatedCart;
        break;

      case TypeKeys.UPDATE_CART_ITEMS:
        var newProps = action.newProps;
        draft.cartItems = newProps;
        break;

      case TypeKeys.UPDATE_DISCOUNTED_CART_ITEMS:
        var discountedCartItems = action.discountedCartItems;
        draft.discountedCartItems = _extends({}, state.discountedCartItems, discountedCartItems);
        break;

      case TypeKeys.DELETE_CART_ITEM:
        var productId = action.productId;
        delete state.cartItems[productId];
        draft.cartItems = Object.assign({}, state.cartItems);
        break;

      case TypeKeys.UPDATE_CART_TOTAL_NUMBER_OF_ITEMS:
        draft.cartTotalNumberOfItems = action.cartTotalNumberOfItems;
        break;

      case TypeKeys.UPDATE_CART_VIA_QUALIFIED_TOTAL:
        draft.viaQualifiedCartTotal = action.viaQualifiedCartTotal;
        break;

      case TypeKeys.UPDATE_AUTOSHIP_ENABLED:
        draft.autoShipEnabled = action.autoShipEnabled;
        break;

      case TypeKeys.UPDATE_AUTOSHIP_AT_TOP:
        draft.autoShipAtTop = action.autoShipAtTop;
        break;

      case TypeKeys.UPDATE_AUTOSHIP_COUNT:
        draft.autoShipIntervalCount = action.autoShipIntervalCount;
        break;

      case TypeKeys.UPDATE_ENROLLING_AS_PC:
        draft.enrollingAsPc = action.enrollingAsPc;
        break;

      case TypeKeys.UPDATE_IS_USER_A_PC:
        draft.isUserPc = action.isUserPc;
        break;

      case TypeKeys.UPDATE_HAS_GATED_ITEM_IN_CART:
        var hasGatedItemInCart = action.hasGatedItemInCart;
        draft.hasGatedItemInCart = hasGatedItemInCart;
        break;

      case TypeKeys.UPDATE_PC_SALE_SUBSCRIPTION_DIALOG:
        draft.pCSaleSubscriptionDialogOpen = action.pCSaleSubscriptionDialogOpen;
        break;
    }
  });
}

var DisabledCartItemsDictionary;

(function (DisabledCartItemsDictionary) {
  DisabledCartItemsDictionary["PC_SUBSCRIPTION_ID"] = "784f3fe8-b3d7-496a-bb23-78e6fe9d0b6e";
  DisabledCartItemsDictionary["MARIS_PICKS_SUBSCRIPTION_ID"] = "e59cd67d-084f-48c4-b51f-3d20750e793f";
})(DisabledCartItemsDictionary || (DisabledCartItemsDictionary = {}));

var PWPDictionary;

(function (PWPDictionary) {
  PWPDictionary["PURCHASE_WITH_PURCHASE_APRIL_MIXED_PACK"] = "ce902835-0016-405a-9bdd-a16672b2739f";
  PWPDictionary["PURCHASE_WITH_PURCHASE_MAY_MIXED_PACK"] = "2539a0e2-d34f-4d1d-9763-a8e8cd8e2048";
  PWPDictionary["PURCHASE_WITH_PURCHASE_JUNE_MIXED_PACK"] = "cf950e4b-8719-4a85-a337-d099d852a0bd";
  PWPDictionary["PURCHASE_WITH_PURCHASE_AUGUST_MIXED_PACK"] = "bc47e019-35a8-4eeb-96e8-cc36f853b5cc";
  PWPDictionary["PURCHASE_WITH_PURCHASE_SEPTEMBER_MIXED_PACK"] = "4d48e61f-87a2-4187-a225-23eb051e88c7";
  PWPDictionary["PURCHASE_WITH_PURCHASE_OCTOBER_MIXED_PACK"] = "e4c74c94-b969-42cd-95cb-179bd5306c14";
  PWPDictionary["PURCHASE_WITH_PURCHASE_NOVEMBER_MIXED_PACK"] = "89f94a2b-72f1-4c7b-adb9-e1181663878d";
  PWPDictionary["PURCHASE_WITH_PURCHASE_DECEMBER_MIXED_PACK"] = "9bf289dd-bc38-4afb-9d9c-3db90875d9d6";
  PWPDictionary["PURCHASE_WITH_PURCHASE_JANUARY_MIXED_PACK"] = "c3d0aa33-6560-42b3-82ef-136669aeef9d";
  PWPDictionary["PURCHASE_WITH_PURCHASE_FEBRUARY_MIXED_PACK"] = "676bc92a-1b38-4a16-8ff1-ea76936e136b";
  PWPDictionary["PURCHASE_WITH_PURCHASE_MARCH_MIXED_PACK"] = "16dd99f3-5a31-43ac-832a-243579fedb15";
  PWPDictionary["PURCHASE_WITH_PURCHASE_APRIL_MIXED_PACK_2021"] = "92c0709c-55d8-421b-a673-dc24d020ec81";
  PWPDictionary["PURCHASE_WITH_PURCHASE_MAY_MIXED_PACK_2021"] = "7e86bc10-4203-4078-a006-ba8394422f20";
})(PWPDictionary || (PWPDictionary = {}));

function numberWithCommas(x) {
  return x ? x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';
}
function buildCart(cart) {
  var _cart$entries, _cart$entries2;

  var cartItems = cart === null || cart === void 0 ? void 0 : (_cart$entries = cart.entries) === null || _cart$entries === void 0 ? void 0 : _cart$entries.edges;
  var nonQualifyingItems = cart === null || cart === void 0 ? void 0 : (_cart$entries2 = cart.entries) === null || _cart$entries2 === void 0 ? void 0 : _cart$entries2.edges;
  var discountQualifyingItems = null;

  if (cart !== null && cart !== void 0 && cart.canSubscribeForAutoShip) {
    var _partition2 = _partition(cartItems, function (item) {
      var _item$node;

      return !!(item !== null && item !== void 0 && (_item$node = item.node) !== null && _item$node !== void 0 && _item$node.discountEligible);
    });

    discountQualifyingItems = _partition2[0];
    nonQualifyingItems = _partition2[1];
  }

  return {
    discountQualifyingItems: discountQualifyingItems,
    nonQualifyingItems: nonQualifyingItems
  };
}
function isSubscriptionItem(productId) {
  return DisabledCartItemsDictionary.PC_SUBSCRIPTION_ID === productId || DisabledCartItemsDictionary.MARIS_PICKS_SUBSCRIPTION_ID === productId;
}
function getCapQuantity(productId, pwpConfig) {
  var configItem = getPwpConfigItem(productId, pwpConfig);
  return (configItem === null || configItem === void 0 ? void 0 : configItem.capQuantity) || null;
}
function getPwpInfo(cartItems, productId, pwpConfig) {
  var cartQty = cartItems && productId ? cartItems[productId] : 0;
  var capQuantity = getCapQuantity(productId, pwpConfig);
  var hidePlusMinus = !!(capQuantity === 1);
  var addButtonEnabled = cartQty && capQuantity ? cartQty < capQuantity : true;
  return {
    addButtonEnabled: addButtonEnabled,
    hidePlusMinus: hidePlusMinus
  };
}
function getCartItems(cart) {
  var _cart$entries3, _cart$entries3$edges;

  return cart === null || cart === void 0 ? void 0 : (_cart$entries3 = cart.entries) === null || _cart$entries3 === void 0 ? void 0 : (_cart$entries3$edges = _cart$entries3.edges) === null || _cart$entries3$edges === void 0 ? void 0 : _cart$entries3$edges.reduce(function (acc, cur) {
    var _cur$node, _cur$node2, _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[cur === null || cur === void 0 ? void 0 : (_cur$node = cur.node) === null || _cur$node === void 0 ? void 0 : _cur$node.productId] = cur === null || cur === void 0 ? void 0 : (_cur$node2 = cur.node) === null || _cur$node2 === void 0 ? void 0 : _cur$node2.quantity, _extends2));
  }, {});
} // export function getFilteredCart(cart: CartType) {
function getPromoCode(cart) {
  var _cart$promoCodes2;

  return (cart === null || cart === void 0 ? void 0 : cart.promoCodes) && (cart === null || cart === void 0 ? void 0 : (_cart$promoCodes2 = cart.promoCodes) === null || _cart$promoCodes2 === void 0 ? void 0 : _cart$promoCodes2.length) > 0 && (cart === null || cart === void 0 ? void 0 : cart.promoCodes[0]);
}
function getFormattedPromoCode(promo) {
  var _promo$code, _promo$code$toUpperCa;

  return (promo === null || promo === void 0 ? void 0 : (_promo$code = promo.code) === null || _promo$code === void 0 ? void 0 : (_promo$code$toUpperCa = _promo$code.toUpperCase()) === null || _promo$code$toUpperCa === void 0 ? void 0 : _promo$code$toUpperCa.replace('GRAPEFULCLUB', 'PREFERREDCUSTOMER')) || '';
}
function getPwpProduct(productsBulk, pwpConfig, flags) {
  var _productsBulk$edges;

  if (!flags || !productsBulk) return null;
  var newPwp = pwpConfig[0];
  var oldPwp = pwpConfig[1];
  var newPwpFlag = flags && flags[newPwp.ldFlag];
  var oldPwpFlag = flags && flags[oldPwp.ldFlag];
  var pwpProductId = '';

  if (newPwpFlag) {
    pwpProductId = newPwp.productId;
  } else if (oldPwpFlag) {
    pwpProductId = oldPwp.productId;
  }

  if (pwpProductId === '') return null;
  var productEdge = productsBulk === null || productsBulk === void 0 ? void 0 : (_productsBulk$edges = productsBulk.edges) === null || _productsBulk$edges === void 0 ? void 0 : _productsBulk$edges.find(function (edge) {
    var _edge$node;

    if (!edge || !edge.node) return false;
    return (edge === null || edge === void 0 ? void 0 : (_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.productId) === pwpProductId;
  });
  return productEdge ? productEdge.node : null;
}
function getPwpConfigItem(productId, pwpConfig) {
  var activeItem = pwpConfig.filter(function (item) {
    return productId === item.productId;
  });
  return activeItem.length ? activeItem[0] : null;
} // export function shouldDisplayPwPDialog({ viaQualifiedCartTotal, pwpProduct, cartItems }: { viaQualifiedCartTotal: number, pwpProduct: ProductType, cartItems: any }) {
//     const isShop = !window.location.pathname.includes('myshop') && window.location.pathname.includes('shop');
//     return isShop && !!pwpProduct && !cartItems[pwpProduct.productId] && viaQualifiedCartTotal % 6 === 0 && viaQualifiedCartTotal > 0;
// }

function getRewardsFlag(flags) {
  return flags && flags.rewardPoints;
}

var CartContext = /*#__PURE__*/createContext();
function CartProvider(_ref) {
  var children = _ref.children,
      user = _ref.user,
      productsBulk = _ref.productsBulk;
  var cart = user === null || user === void 0 ? void 0 : user.cartV2;

  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      flags = _useCartNetworkLayerV.flags,
      pwpConfig = _useCartNetworkLayerV.pwpConfig;

  var autoShipEnabled = cart.autoShipEnabled,
      autoShipIntervalCount = cart.autoShipIntervalCount,
      canSubscribeForAutoShip = cart.canSubscribeForAutoShip;
  var isUserPc = true; //isPreferredCustomer(user);

  var pwpProduct = getPwpProduct(productsBulk, pwpConfig, flags); // const cartHasPCSubscription = true; //hasPCSubscription(cart);

  var filteredCart = cart; //getFilteredCart(cart);

  var cartItems = getCartItems(cart);
  var cartTotalNumberOfItems = cart === null || cart === void 0 ? void 0 : cart.totalNumberOfItems;
  var viaQualifiedCartTotal = cart === null || cart === void 0 ? void 0 : cart.discountQualifiedCartTotal;
  var initialState = {
    pwpProduct: pwpProduct,
    enrollingAsPc: false,
    autoShipEnabled: autoShipEnabled,
    autoShipIntervalCount: autoShipIntervalCount,
    isUserPc: isUserPc,
    cart: filteredCart || {},
    cartItems: cartItems,
    hasGatedItemInCart: false,
    viaQualifiedCartTotal: viaQualifiedCartTotal,
    cartTotalNumberOfItems: cartTotalNumberOfItems,
    pCSaleSubscriptionDialogOpen: false,
    autoShipAtTop: !!canSubscribeForAutoShip
  }; // @ts-ignore

  var sync = useReducer(reducer, initialState);
  return React__default.createElement(CartContext.Provider, {
    value: sync
  }, children);
}
var useCartContextValue = function useCartContextValue() {
  return useContext(CartContext);
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var _s$cssConstants = styles.cssConstants,
    primaryColor = _s$cssConstants.primaryColor,
    tertiaryFont = _s$cssConstants.tertiaryFont,
    bronzeNeutral3 = _s$cssConstants.bronzeNeutral3;
var ItemCount = /*#__PURE__*/styled.div(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-weight: normal;\n  text-transform: uppercase;\n"])));
var HeaderContainer = /*#__PURE__*/styled.div(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 40px;\n"])));
var HeaderWrapper = /*#__PURE__*/styled.div(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 0 16px;\n  color: ", ";\n  background-color: ", ";\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.01em;\n  font-family: ", "\n"])), primaryColor, bronzeNeutral3, tertiaryFont); // const IconButton = styled(MuiIconButton)`
//   &.MuiIconButton-root {
//     padding: 3px !important;
//     border-radius: 50% !important;
//   }
//   .MuiSvgIcon-root {
//     width: 1.2em;
//     height: 1.2em;
//   }
// `;
//
// const LockIcon = styled(MuiLockIcon)`
//   && {
//     width: 12px;
//     height: 12px;
//     padding-right: 4px;
//   }
// `;
//
// const InformationSecure = styled.div`
//   display: flex;
//   align-items: center;
//   font-style: normal;
//   font-weight: normal;
//   font-size: 11px;
//   line-height: 16px;
//   font-family: ${tertiaryFont};
// `;

var ContinueShopping = /*#__PURE__*/styled.div(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  text-decoration: underline;\n  font-weight: 600;\n  :hover {\n    cursor: pointer;\n  }\n"])));
var Header = (function () {
  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      toggleCartClosed = _useCartNetworkLayerV.toggleCartClosed,
      handleAddMoreItems = _useCartNetworkLayerV.handleAddMoreItems;

  var _useCartContextValue = useCartContextValue(),
      cartTotalNumberOfItems = _useCartContextValue[0].cartTotalNumberOfItems;

  var onKeepShopping = function onKeepShopping(e) {
    toggleCartClosed();

    if (handleAddMoreItems) {
      handleAddMoreItems(e);
    }
  };

  return React__default.createElement(HeaderWrapper, null, React__default.createElement(HeaderContainer, null, React__default.createElement(ItemCount, null, "Your Cart (", cartTotalNumberOfItems, ")"), React__default.createElement(ContinueShopping, {
    "aria-label": "close",
    onClick: onKeepShopping
  }, "Continue Shopping")));
});

var _templateObject$1;
var Image = /*#__PURE__*/styled.img(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  height: 80px;\n  width: 80px;\n  :hover {\n    cursor: pointer;\n  }\n"])));
var ShopImage = (function (props) {
  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      assetsUrl = _useCartNetworkLayerV.assetsUrl;

  return React__default.createElement(Image, {
    role: 'button',
    alt: props.alt,
    onClick: props.onClick,
    src: "" + assetsUrl + props.slug
  });
});

function Currency(_ref) {
  var rawValue = _ref.rawValue,
      _ref$includeCents = _ref.includeCents,
      includeCents = _ref$includeCents === void 0 ? true : _ref$includeCents;

  if (!includeCents) {
    return createElement(Fragment, null, "$", rawValue.toLocaleString(undefined, {
      maximumFractionDigits: 0
    }));
  }

  var formattedValue = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(rawValue);
  return createElement(Fragment, null, formattedValue);
}

var _templateObject$2, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5;
var _styles$cssConstants = styles.cssConstants,
    primaryColor$1 = _styles$cssConstants.primaryColor,
    neutral100 = _styles$cssConstants.neutral100,
    tertiaryFont$1 = _styles$cssConstants.tertiaryFont;
var PriceContainer = /*#__PURE__*/styled.div(_templateObject$2 || (_templateObject$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin-bottom: 8px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 21px;\n  letter-spacing: 0.01em;\n  font-family: ", ";\n"])), tertiaryFont$1);
var PriceRegular = /*#__PURE__*/styled.div(_templateObject2$1 || (_templateObject2$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-weight: normal;\n"])));
var PriceSale = /*#__PURE__*/styled.span(_templateObject3$1 || (_templateObject3$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 21px;\n  text-align: right;\n  letter-spacing: 0.01em;\n  color: ", ";\n  text-decoration: line-through;\n  padding-right: 8px;\n"])), neutral100);
var AmountSaved = /*#__PURE__*/styled.div(_templateObject4$1 || (_templateObject4$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 18px;\n  float: left;\n  font-size: 10px;\n  font-weight: bold;\n  font-style: normal;\n  line-height: 14px;\n  letter-spacing: 0.25em;\n  font-stretch: normal;\n  text-align: center;\n  color: white;\n  background-color: ", ";\n  text-transform: uppercase;\n  margin-top: 8px;\n  padding: 0 4px;\n"])), primaryColor$1);
var DiscountContainer = /*#__PURE__*/styled.div(_templateObject5 || (_templateObject5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"]))); // function percentOf(numerator: number | null, denominator: number): number {
//   return Math.round((denominator - (numerator || 0)) / denominator * 100);
// }

function PriceTag(_ref) {
  var product = _ref.product;
  var priceOriginal = product.priceOriginal,
      priceDiscount = product.priceDiscount,
      priceDiscountPercent = product.priceDiscountPercent; // const showSalePrice = !!(discountAmount || priceSale);
  // const savingsFromSale =
  //   (priceSale && new Decimal(priceOriginal).minus(priceSale).toNumber()) || 0;

  var amountSaved = priceDiscountPercent ? jsx(AmountSaved, null, "Save", ' ', " ", Math.round(100 * (priceDiscountPercent * 100)) / 100, " %") : null;
  return jsx(PriceContainer, null, jsx(DiscountContainer, null, !!priceDiscountPercent && jsx(PriceSale, null, jsx(Currency, {
    rawValue: priceOriginal
  })), jsx(PriceRegular, null, jsx(Currency, {
    rawValue: priceDiscount
  }))), amountSaved);
}

var _templateObject$3;
var cssConstants = styles.cssConstants;
var TextField = /*#__PURE__*/styled(MuiTextField)(_templateObject$3 || (_templateObject$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  .MuiInputBase-root {\n    width: 30px;\n    height: 30px;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 18px;\n    letter-spacing: 0.01em;\n    font-family: ", ";\n  }\n  .MuiInputBase-input {\n    padding: 0;\n    text-align: center;\n  }\n"])), cssConstants.tertiaryFont);
var CssTextField = /*#__PURE__*/withStyles({
  root: {
    '& label.Mui-focused': {
      borderWidth: 0,
      color: cssConstants.primaryColor
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderWidth: 0,
        borderColor: cssConstants.primaryColor
      },
      '&:hover fieldset': {
        borderWidth: 0,
        borderColor: cssConstants.primaryColor
      },
      // '&.Mui-focused': {
      //   fontWeight: 'normal',
      // },
      '&.Mui-focused fieldset': {
        borderWidth: 0,
        borderColor: cssConstants.primaryColor
      }
    }
  }
})(TextField);
function CartItemInput(_ref) {
  var quantity = _ref.quantity,
      product = _ref.product,
      sku = _ref.sku,
      isC4CProduct = _ref.isC4CProduct;

  var _useState = useState(false),
      didMount = _useState[0],
      setDidMount = _useState[1];

  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      handleCartAdd = _useCartNetworkLayerV.handleCartAdd,
      user = _useCartNetworkLayerV.user,
      cartMutationLoading = _useCartNetworkLayerV.cartMutationLoading,
      pwpConfig = _useCartNetworkLayerV.pwpConfig;

  var _useCartContextValue = useCartContextValue(),
      state = _useCartContextValue[0],
      dispatch = _useCartContextValue[1];

  var _useState2 = useState(quantity === null || quantity === void 0 ? void 0 : quantity.toString()),
      cartItemQty = _useState2[0],
      setCartItemQty = _useState2[1];

  useEffect(function () {
    setDidMount(true);
  }, []);
  useEffect(function () {
    if (didMount) {
      setCartItemQty(quantity === null || quantity === void 0 ? void 0 : quantity.toString());
    }
  }, [quantity]);

  var onChange = function onChange(e) {
    var value = e.target.value;

    if (value === '' || isNumeric(value) && Number(value) > 0) {
      setCartItemQty(value);
    }
  };

  var handleOnBlur = function handleOnBlur() {
    var numericCartItemQuantity = Number(cartItemQty);
    var capQuantity = getCapQuantity(product === null || product === void 0 ? void 0 : product.productId, pwpConfig);
    var allowChange = numericCartItemQuantity && capQuantity ? numericCartItemQuantity <= capQuantity : true;

    if (!cartMutationLoading && cartItemQty !== '' && quantity !== numericCartItemQuantity && !cartMutationLoading && allowChange) {
      var productId = product.productId,
          isWinePack = product.isWinePack,
          wineBottleQuantity = product.wineBottleQuantity;
      var pwpProduct = state.pwpProduct;

      if (state.cartItems[productId]) {
        var cartItems = Object.keys(state.cartItems);

        if (state.cartItems[productId] === quantity) {
          var _extends2;

          var viaQualifiedCartTotalToIncrement = isWinePack ? (wineBottleQuantity || 6) * (numericCartItemQuantity - state.cartItems[productId]) : numericCartItemQuantity - state.cartItems[productId];
          var quantityChange = numericCartItemQuantity - state.cartItems[productId];
          handleCartAdd(user, cartItems, state.cartItems[productId], quantityChange, product, pwpProduct);
          dispatch({
            type: TypeKeys.UPDATE_CART_ITEMS,
            newProps: _extends({}, state.cartItems, (_extends2 = {}, _extends2[productId] = numericCartItemQuantity, _extends2))
          });
          dispatch({
            type: TypeKeys.UPDATE_CART_TOTAL_NUMBER_OF_ITEMS,
            cartTotalNumberOfItems: state.cartTotalNumberOfItems + quantityChange
          });

          if (isC4CProduct) {
            dispatch({
              type: TypeKeys.UPDATE_CART_VIA_QUALIFIED_TOTAL,
              viaQualifiedCartTotal: (state === null || state === void 0 ? void 0 : state.viaQualifiedCartTotal) + viaQualifiedCartTotalToIncrement
            });
          }
        } else {
          var _extends3;

          var _viaQualifiedCartTotalToIncrement = isWinePack ? (wineBottleQuantity || 6) * (numericCartItemQuantity - quantity) : numericCartItemQuantity - quantity;

          var _quantityChange = numericCartItemQuantity - quantity;

          handleCartAdd(user, cartItems, state.cartItems[productId], _quantityChange, product, pwpProduct);
          dispatch({
            type: TypeKeys.UPDATE_CART_ITEMS,
            newProps: _extends({}, state.cartItems, (_extends3 = {}, _extends3[productId] = state.cartItems[productId] + _quantityChange, _extends3))
          });
          dispatch({
            type: TypeKeys.UPDATE_CART_TOTAL_NUMBER_OF_ITEMS,
            cartTotalNumberOfItems: state.cartTotalNumberOfItems + _quantityChange
          });

          if (isC4CProduct) {
            dispatch({
              type: TypeKeys.UPDATE_CART_VIA_QUALIFIED_TOTAL,
              viaQualifiedCartTotal: (state === null || state === void 0 ? void 0 : state.viaQualifiedCartTotal) + _viaQualifiedCartTotalToIncrement
            });
          }
        }
      }
    } else {
      setCartItemQty(quantity.toString());
    }
  };

  var keyPress = function keyPress(e) {
    if (e.keyCode == 13) {
      // handleOnBlur();
      e.preventDefault();
    }
  };

  return React__default.createElement("form", {
    noValidate: true,
    autoComplete: 'off'
  }, React__default.createElement(CssTextField, {
    id: sku,
    variant: 'outlined',
    value: cartItemQty,
    onChange: onChange,
    onBlur: handleOnBlur,
    onKeyDown: keyPress
  }));
}

var handleCartAddHelper = function handleCartAddHelper(_ref) {
  var state = _ref.state,
      dispatch = _ref.dispatch,
      user = _ref.user,
      product = _ref.product,
      handleCartAdd = _ref.handleCartAdd,
      cartMutationLoading = _ref.cartMutationLoading;
  return function () {
    if (!cartMutationLoading) {
      var _extends2;

      var productId = product.productId,
          isWinePack = product.isWinePack,
          wineBottleQuantity = product.wineBottleQuantity,
          hasQualifyingDiscount = product.hasQualifyingDiscount;
      var pwpProduct = state.pwpProduct;
      var isC4CProduct = !!(product !== null && product !== void 0 && product.discountEligible);
      var cartItems = Object.keys(state.cartItems);
      var currentItemQty = state.cartItems[productId] || 0;
      var viaQualifiedCartTotalToIncrement = hasQualifyingDiscount ? isWinePack ? wineBottleQuantity || 6 : 1 : 0;
      handleCartAdd(user, cartItems, currentItemQty, 1, product, pwpProduct);
      dispatch({
        type: TypeKeys.UPDATE_CART_ITEMS,
        newProps: _extends({}, state.cartItems, (_extends2 = {}, _extends2[productId] = currentItemQty + 1, _extends2))
      });
      dispatch({
        type: TypeKeys.UPDATE_CART_TOTAL_NUMBER_OF_ITEMS,
        cartTotalNumberOfItems: state.cartTotalNumberOfItems + 1
      });

      if (isC4CProduct) {
        dispatch({
          type: TypeKeys.UPDATE_CART_VIA_QUALIFIED_TOTAL,
          viaQualifiedCartTotal: (state === null || state === void 0 ? void 0 : state.viaQualifiedCartTotal) + viaQualifiedCartTotalToIncrement
        });
      }

      if (state.autoShipAtTop && !!((state === null || state === void 0 ? void 0 : state.viaQualifiedCartTotal) < 4)) {
        dispatch({
          type: TypeKeys.UPDATE_AUTOSHIP_AT_TOP,
          autoShipAtTop: false
        });
      }
    }
  };
};
var handleCartMinusHelper = function handleCartMinusHelper(_ref2) {
  var state = _ref2.state,
      dispatch = _ref2.dispatch,
      user = _ref2.user,
      product = _ref2.product,
      handleCartAdd = _ref2.handleCartAdd,
      handleCartDelete = _ref2.handleCartDelete,
      cartMutationLoading = _ref2.cartMutationLoading;
  return function () {
    var productId = product.productId,
        isWinePack = product.isWinePack,
        wineBottleQuantity = product.wineBottleQuantity,
        hasQualifyingDiscount = product.hasQualifyingDiscount;
    var pwpProduct = state.pwpProduct;
    var isC4CProduct = !!(product !== null && product !== void 0 && product.discountEligible);
    var viaQualifiedCartTotalToIncrement = hasQualifyingDiscount ? isWinePack ? wineBottleQuantity || 6 : 1 : 0;

    if (!cartMutationLoading && state.cartItems[productId]) {
      var _extends3;

      var cartItems = Object.keys(state.cartItems);

      if (state.cartItems[productId] === 1) {
        /* delete item when only one cart Itme left */
        if (handleCartDelete) {
          handleCartDelete(user, product);
        }
      } else {
        handleCartAdd(user, cartItems, state.cartItems[productId], -1, product, pwpProduct);
      }

      dispatch({
        type: TypeKeys.UPDATE_CART_ITEMS,
        newProps: _extends({}, state.cartItems, (_extends3 = {}, _extends3[productId] = state.cartItems[productId] - 1, _extends3))
      });
      dispatch({
        type: TypeKeys.UPDATE_CART_TOTAL_NUMBER_OF_ITEMS,
        cartTotalNumberOfItems: state.cartTotalNumberOfItems - 1
      });

      if (isC4CProduct) {
        dispatch({
          type: TypeKeys.UPDATE_CART_VIA_QUALIFIED_TOTAL,
          viaQualifiedCartTotal: (state === null || state === void 0 ? void 0 : state.viaQualifiedCartTotal) - viaQualifiedCartTotalToIncrement
        });
      }

      if (state.autoShipAtTop && !!((state === null || state === void 0 ? void 0 : state.viaQualifiedCartTotal) < 4)) {
        dispatch({
          type: TypeKeys.UPDATE_AUTOSHIP_AT_TOP,
          autoShipAtTop: false
        });
      }
    }
  };
};
var handleCartRemoveHelper = function handleCartRemoveHelper(_ref3) {
  var state = _ref3.state,
      dispatch = _ref3.dispatch,
      user = _ref3.user,
      product = _ref3.product,
      quantity = _ref3.quantity,
      handleCartDelete = _ref3.handleCartDelete,
      handleCartAdd = _ref3.handleCartAdd,
      cartMutationLoading = _ref3.cartMutationLoading;
  return function () {
    var productId = product.productId,
        isWinePack = product.isWinePack,
        wineBottleQuantity = product.wineBottleQuantity,
        hasQualifyingDiscount = product.hasQualifyingDiscount;
    var pwpProduct = state.pwpProduct;
    var isC4CProduct = !!(product !== null && product !== void 0 && product.discountEligible);

    if (!cartMutationLoading && state.cartItems[productId]) {
      var cartItems = Object.keys(state.cartItems);
      var viaQualifiedCartTotalToIncrement = hasQualifyingDiscount ? isWinePack ? (wineBottleQuantity || 6) * state.cartItems[productId] : state.cartItems[productId] : 0;

      if (quantity === state.cartItems[productId]) {
        // const updatedCart = state.cart?.entries?.filter((entry: any) =>  entry.node.productId !== productId);
        if (handleCartDelete) {
          handleCartDelete(user, product);
        }

        dispatch({
          type: TypeKeys.UPDATE_CART_TOTAL_NUMBER_OF_ITEMS,
          cartTotalNumberOfItems: state.cartTotalNumberOfItems - state.cartItems[productId]
        }); // dispatch({
        //     type: TypeKeys.DELETE_CART_ITEM,
        //     productId: productId,
        // });
        // dispatch({
        //     type: TypeKeys.UPDATE_CART,
        //     updatedCart,
        // });

        if (isC4CProduct) {
          dispatch({
            type: TypeKeys.UPDATE_CART_VIA_QUALIFIED_TOTAL,
            viaQualifiedCartTotal: (state === null || state === void 0 ? void 0 : state.viaQualifiedCartTotal) - viaQualifiedCartTotalToIncrement
          });
        }
      } else {
        var _extends4;

        var _viaQualifiedCartTotalToIncrement = hasQualifyingDiscount ? isWinePack ? (wineBottleQuantity || 6) * quantity : quantity : 0;

        handleCartAdd(user, cartItems, state.cartItems[productId], -quantity, product, pwpProduct);
        dispatch({
          type: TypeKeys.UPDATE_CART_ITEMS,
          newProps: _extends({}, state.cartItems, (_extends4 = {}, _extends4[productId] = state.cartItems[productId] - quantity, _extends4))
        });
        dispatch({
          type: TypeKeys.UPDATE_CART_TOTAL_NUMBER_OF_ITEMS,
          cartTotalNumberOfItems: state.cartTotalNumberOfItems - quantity
        });

        if (isC4CProduct) {
          dispatch({
            type: TypeKeys.UPDATE_CART_VIA_QUALIFIED_TOTAL,
            viaQualifiedCartTotal: (state === null || state === void 0 ? void 0 : state.viaQualifiedCartTotal) - _viaQualifiedCartTotalToIncrement
          });
        }
      }

      if (state.autoShipAtTop && !!((state === null || state === void 0 ? void 0 : state.viaQualifiedCartTotal) < 4)) {
        dispatch({
          type: TypeKeys.UPDATE_AUTOSHIP_AT_TOP,
          autoShipAtTop: false
        });
      }
    }
  };
};

function Close() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10",
    fill: "none",
    viewBox: "0 0 10 10"
  }, React__default.createElement("path", {
    stroke: "#373634",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "0.75",
    d: "M1 9l8-8M1 1l8 8"
  }));
}

function Add() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10",
    fill: "none",
    viewBox: "0 0 10 10"
  }, React__default.createElement("path", {
    stroke: "#373634",
    strokeLinejoin: "round",
    strokeWidth: "0.75",
    d: "M5 0v10M0 5h10"
  }));
}

function Minus() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "2",
    fill: "none",
    viewBox: "0 0 10 2"
  }, React__default.createElement("path", {
    stroke: "#373634",
    strokeLinejoin: "round",
    strokeWidth: "0.75",
    d: "M0 1h10"
  }));
}

var _templateObject$4, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$1, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
var cssConstants$1 = styles.cssConstants;
var CartItemContainer = /*#__PURE__*/styled.div(_templateObject$4 || (_templateObject$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  font-family: ", ";\n  padding-bottom: 24px;\n"])), cssConstants$1.tertiaryFont);
var CartItemTopContainer = /*#__PURE__*/styled.div(_templateObject2$2 || (_templateObject2$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"])));
var ProductName = /*#__PURE__*/styled.div(_templateObject3$2 || (_templateObject3$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  line-height: 21px;\n  padding-bottom: 8px;\n  letter-spacing: 0.01em;\n  width: 100%;\n"]))); // const IconButton = styled(MuiIconButton)`
//   &&.MuiIconButton-sizeSmall {
//     padding: 3px;
//     border-radius: 50%;
//     background-color: ${cssConstants.neutral5};
//     width: 40px;
//     height: 40px;
//     margin-right: 8px;
//   }
// `;
//
// const RemoveIcon = styled(MuiRemoveIcon)`
//   && {
//     color: black !important;
//   }
// `;
//
// const AddIcon = styled(MuiAddIcon)<{ disabled: boolean }>`
//   && {
//     color: ${({ disabled }: { disabled: boolean }) =>
//       disabled ? cssConstants.disabledColor : 'black !important'};
//   }
// `;

var RemoveButton = /*#__PURE__*/styled.div(_templateObject4$2 || (_templateObject4$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  height: 30px;\n  :hover {\n    cursor: pointer;\n  }\n"])));
var AddButton = /*#__PURE__*/styled.button(_templateObject5$1 || (_templateObject5$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  text-align: center;\n  width: 30px;\n  :hover {\n    cursor: pointer;\n  }\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n"])));
var MinusButton = /*#__PURE__*/styled.button(_templateObject6 || (_templateObject6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin-top: -8px;\n  text-align: center;\n  width: 30px;\n  :hover {\n    cursor: pointer;\n  }\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n"])));
var CartItemSummaryContainer = /*#__PURE__*/styled.div(_templateObject7 || (_templateObject7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  //align-items: flex-end;\n"])));
var CartItemQuantityControlContainer = /*#__PURE__*/styled.div(_templateObject8 || (_templateObject8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 30px;\n  align-content: center;\n"])));
var ProductContent = /*#__PURE__*/styled.div(_templateObject9 || (_templateObject9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 0 8px;\n  display: flex;\n  flex-direction: column;\n"])));
var QtyText = /*#__PURE__*/styled.div(_templateObject10 || (_templateObject10 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 16px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  padding-right: 16px;\n"]))); // const GatedProduct = styled.div`
//   font-size: 12px;
//   color: white;
//   background-color: black;
//   padding: 16px 20px 24px 20px;
//   margin-bottom: 16px;
//   border-radius: 5px;
//   text-align: center;
//   box-shadow: 2px 2px 4px grey;
// `;

var isWineClubSlug = function isWineClubSlug(productURLslug) {
  return productURLslug === 'maris-picks' || productURLslug === 'wine-club' || productURLslug === 'wine-club-4-pack' || productURLslug === 'wine-club-6-pack' || productURLslug === 'wine-club-12-pack';
};
function CartItem(_ref) {
  var sku = _ref.sku,
      product = _ref.product,
      quantity = _ref.quantity;

  var _useCartContextValue = useCartContextValue(),
      state = _useCartContextValue[0],
      dispatch = _useCartContextValue[1];

  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      handleCartAdd = _useCartNetworkLayerV.handleCartAdd,
      handleCartDelete = _useCartNetworkLayerV.handleCartDelete,
      user = _useCartNetworkLayerV.user,
      cartMutationLoading = _useCartNetworkLayerV.cartMutationLoading,
      pwpConfig = _useCartNetworkLayerV.pwpConfig,
      handleGoToProductDetailsPage = _useCartNetworkLayerV.handleGoToProductDetailsPage;

  var productId = product.productId,
      productURLslug = product.productURLslug; // const gatedPCProduct = false; //isGatedPCProduct(user, product);

  var belongsToSubscription = isSubscriptionItem(productId);
  var cartItems = state.cartItems;
  var isWineClubProduct = isWineClubSlug(productURLslug);

  var _getPwpInfo = getPwpInfo(cartItems, productId, pwpConfig),
      addButtonEnabled = _getPwpInfo.addButtonEnabled,
      hidePlusMinus = _getPwpInfo.hidePlusMinus; // const isC4CProduct = !!product?.promoCodeDiscount?.case4Cause?.case6PriceUSD;


  var dispatchHandleCartAdd = handleCartAddHelper({
    state: state,
    dispatch: dispatch,
    user: user,
    product: product,
    handleCartAdd: handleCartAdd,
    cartMutationLoading: cartMutationLoading
  });
  var dispatchHandleCartMinus = handleCartMinusHelper({
    state: state,
    dispatch: dispatch,
    user: user,
    product: product,
    handleCartAdd: handleCartAdd,
    handleCartDelete: handleCartDelete,
    cartMutationLoading: cartMutationLoading
  });
  var dispatchHandleCartRemove = handleCartRemoveHelper({
    state: state,
    dispatch: dispatch,
    user: user,
    quantity: quantity,
    product: product,
    handleCartAdd: handleCartAdd,
    handleCartDelete: handleCartDelete,
    cartMutationLoading: cartMutationLoading
  });
  var dispatchHandleGoToProductDetailsPage = handleGoToProductDetailsPage(productURLslug);
  return React__default.createElement(React__default.Fragment, null, (product === null || product === void 0 ? void 0 : product.id) && React__default.createElement(React__default.Fragment, null, React__default.createElement(CartItemContainer, null, React__default.createElement(CartItemTopContainer, null, React__default.createElement(CartItemSummaryContainer, null, React__default.createElement(ShopImage, {
    onClick: dispatchHandleGoToProductDetailsPage,
    slug: product === null || product === void 0 ? void 0 : product.productImageUrl,
    alt: (product === null || product === void 0 ? void 0 : product.productName) || 'no image'
  }), React__default.createElement(ProductContent, null, React__default.createElement(ProductName, null, product === null || product === void 0 ? void 0 : product.productName), React__default.createElement(PriceTag, {
    product: product
  }), !belongsToSubscription && !hidePlusMinus && !isWineClubProduct && React__default.createElement(CartItemQuantityControlContainer, null, React__default.createElement(QtyText, null, "QTY:"), React__default.createElement(MinusButton, {
    onClick: dispatchHandleCartMinus
  }, React__default.createElement(Minus, null)), React__default.createElement(CartItemInput, {
    sku: sku,
    quantity: quantity,
    product: product,
    isC4CProduct: !!(product !== null && product !== void 0 && product.discountEligible)
  }), addButtonEnabled && React__default.createElement(AddButton, {
    onClick: addButtonEnabled ? dispatchHandleCartAdd : function () {}
  }, React__default.createElement(Add, null))))), React__default.createElement(RemoveButton, {
    onClick: dispatchHandleCartRemove
  }, React__default.createElement(Close, null))))));
}

var _templateObject$5;
var MutedHorizontalRule = /*#__PURE__*/styled.div(_templateObject$5 || (_templateObject$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 100%;\n  border-bottom: 1px solid #E5D2C3;\n  margin-bottom: 16px;\n"])));
function CartItems(_ref) {
  var items = _ref.items,
      keyString = _ref.keyString,
      showDiscountedCart = _ref.showDiscountedCart;
  return React__default.createElement(React__default.Fragment, null, items === null || items === void 0 ? void 0 : items.map(function (cartEntry, index) {
    var _cartEntry$node = cartEntry.node,
        quantity = _cartEntry$node.quantity,
        sku = _cartEntry$node.sku,
        productId = _cartEntry$node.productId;
    return React__default.createElement(React__default.Fragment, {
      key: keyString + "-" + (sku || productId) + index
    }, showDiscountedCart && keyString === 'nonDiscountedCartItem' && index === 0 && React__default.createElement(MutedHorizontalRule, {
      key: keyString + "-hr-" + index
    }), React__default.createElement(CartItem, {
      key: keyString + "-" + sku + index,
      sku: sku || productId,
      product: cartEntry.node,
      quantity: quantity || 0
    }));
  }));
}

function FYISvg() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "80",
    height: "80",
    viewBox: "0 0 80 80"
  }, React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0 0h80v80H0z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#1A1A1A",
    d: "M10.5 32.5v38.309h28.769V38.336a5.849 5.849 0 00-1.692-4.123 5.732 5.732 0 00-4.085-1.713H10.5z"
  }), React__default.createElement("path", {
    fill: "#DDD",
    fillRule: "nonzero",
    stroke: "#1A1A1A",
    d: "M68.816 32.5H45.824a5.732 5.732 0 00-4.085 1.713 5.849 5.849 0 00-1.692 4.123V70.81h28.769V32.5z"
  }), React__default.createElement("path", {
    stroke: "#1A1A1A",
    strokeLinecap: "square",
    d: "M46.019 41.276h17.509m-17.509 8.827h17.509m-17.509 9.931h17.509"
  }), React__default.createElement("text", {
    fill: "#F4564E",
    fontFamily: "GothamHTF-Black, Gotham HTF",
    fontSize: "13",
    fontWeight: "700",
    letterSpacing: "0.39",
    transform: "translate(11 33)"
  }, React__default.createElement("tspan", {
    x: "2",
    y: "24"
  }, "FYI")), React__default.createElement("g", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, React__default.createElement("path", {
    fill: "#FAAD14",
    d: "M28.29 32.026H25V20.513C25 14.155 30.15 9 36.517 9h7.23c6.36 0 11.516 5.153 11.516 11.513v11.513H28.29zm16.447 0h-9.21"
  }), React__default.createElement("g", {
    transform: "translate(31 18)"
  }, React__default.createElement("circle", {
    cx: "2.5",
    cy: "1.5",
    r: "1.5",
    fill: "#FF4D4F"
  }), React__default.createElement("circle", {
    cx: "15.5",
    cy: "1.5",
    r: "1.5",
    fill: "#FF4D4F"
  }), React__default.createElement("path", {
    fill: "#FFF",
    d: "M0 5h18.286v2c0 1.105-.895 2-1.992 2H1.992C.892 9 0 8.112 0 7V5z"
  }), React__default.createElement("path", {
    d: "M3.429 5.571v2.914m2.857-2.914v2.914m2.857-2.914v2.914M12 5.571v2.914m2.857-2.914v2.914"
  })), React__default.createElement("path", {
    d: "M22 32.026h3.289m30.264 0h3.289"
  }), React__default.createElement("path", {
    fill: "#FF4D4F",
    d: "M29.21 32.027c0-1.09.887-1.974 1.977-1.974h3.283c1.092 0 1.978.876 1.978 1.974V34H29.21v-1.973z"
  }), React__default.createElement("path", {
    d: "M31.842 34v-1.973M33.815 34v-1.973"
  }), React__default.createElement("path", {
    fill: "#FF4D4F",
    d: "M44.342 32.027c0-1.09.887-1.974 1.977-1.974h3.283c1.092 0 1.978.876 1.978 1.974V34h-7.238v-1.973z"
  }), React__default.createElement("path", {
    d: "M46.974 34v-1.973M48.947 34v-1.973"
  }))));
}

var _templateObject$6, _templateObject2$3, _templateObject3$3, _templateObject4$3, _templateObject5$2, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1;
var cssConstants$2 = styles.cssConstants;
var Dialog = /*#__PURE__*/styled(MuiDialog)(_templateObject$6 || (_templateObject$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &.MuiDialog-root {\n    z-index: 10002 !important;\n  }\n"])));
var IconButton = /*#__PURE__*/styled(MuiIconButton)(_templateObject2$3 || (_templateObject2$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  /* margin: 0px 0px 0px auto; */\n  right: 0px !important;\n  position: absolute !important;\n  padding: 10px !important;\n"])));
var CloseIcon = /*#__PURE__*/styled(CloseIcon$1)(_templateObject3$3 || (_templateObject3$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: '#3C3C3C';\n  font-size: 2rem !important;\n"])));
var SvgContainer = /*#__PURE__*/styled.div(_templateObject4$3 || (_templateObject4$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  text-align: center;\n  padding-top: 55px;\n"])));
var TitleText = /*#__PURE__*/styled.div(_templateObject5$2 || (_templateObject5$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-size: 32px;\n  font-weight: bold;\n  text-align: center;\n"])), cssConstants$2.font);
var InfoText = /*#__PURE__*/styled.div(_templateObject6$1 || (_templateObject6$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: '8px 64px';\n  text-align: 'center';\n  font-family: ", ";\n  line-height: 1.3;\n"])), cssConstants$2.font);
var InfoTextContainer = /*#__PURE__*/styled.div(_templateObject7$1 || (_templateObject7$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 8px 64px;\n  text-align: 'center';\n  font-family: ", ";\n"])), cssConstants$2.font);
var ButtonStyle = /*#__PURE__*/styled.div(_templateObject8$1 || (_templateObject8$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 240px;\n  height: 40px;\n"])));
var ButtonContainer = /*#__PURE__*/styled.div(_templateObject9$1 || (_templateObject9$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  padding: 24px;\n  margin-bottom: 25px;\n"])));
function BlackFridaySaleDialog(props) {
  var onClose = props.onClose,
      open = props.open;
  var theme = useTheme();
  var fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return createElement(Dialog, {
    onClose: onClose,
    fullWidth: true,
    scroll: "paper",
    open: open,
    fullScreen: fullScreen
  }, createElement("div", null, createElement(IconButton, {
    "aria-label": "Close",
    onClick: onClose
  }, createElement(CloseIcon, null)), createElement("div", null, createElement(SvgContainer, null, createElement(FYISvg, null)), createElement(TitleText, null, "Heads up!"), createElement(InfoTextContainer, null, createElement(InfoText, null, "The wine you are ordering today is specially priced for a limited-time promotion. Your future subscription shipments will be priced according to our standard Preferred Customer discounts of 5% off 4 bottles, 10% off 6 bottles, and 20% off 12 bottles.")), createElement(ButtonContainer, null, createElement(ButtonStyle, null, createElement(MuiButton, {
    type: "PRIMARY",
    onClick: onClose
  }, "Ok, sounds good"))))));
}

var _templateObject$7;
var cssConstants$3 = styles.cssConstants; // const BlackCheckbox = withStyles({
//   root: {
//     // marginRight: -8,
//     marginTop: -12,
//     borderRadius: '50%',
//     color: '#C4AD9E',
//     minWidth: '0 !important',
//     '&$checked': {
//       color: cssConstants.bronzeNeutral5,
//     },
//     '&&:hover': {
//       backgroundColor: 'transparent',
//     },
//   },
//   checked: {
//     minWidth: '0 !important',
//   },
// })((props: CheckboxProps) => (
//     <Checkbox disableRipple color="default" {...props} />
// ));

var CheckButton = /*#__PURE__*/styled(Checkbox)(_templateObject$7 || (_templateObject$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &.MuiCheckbox-root {\n    margin-top: -12px;\n    margin-right: -8px;\n    border-radius: 50%;\n    color: #c4ad9e;\n    min-width: 0 !important;\n    :hover {\n      background-color: transparent;\n    }\n  }\n  &.Mui-checked {\n    color: ", ";\n    width: inherit !important;\n  }\n"])), cssConstants$3.bronzeNeutral5);
function CheckboxContainer() {
  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      user = _useCartNetworkLayerV.user,
      handleCartAutoshipToggle = _useCartNetworkLayerV.handleCartAutoshipToggle,
      flags = _useCartNetworkLayerV.flags;

  var _useCartContextValue = useCartContextValue(),
      autoShipEnabled = _useCartContextValue[0].autoShipEnabled,
      dispatch = _useCartContextValue[1];

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var handleCloseDialog = function handleCloseDialog() {
    setOpen(false);
  };

  var handleChange = function handleChange(event) {
    handleCartAutoshipToggle(user.cartV2, event.target.checked);
    dispatch({
      type: TypeKeys.UPDATE_AUTOSHIP_ENABLED,
      autoShipEnabled: event.target.checked
    });
    if (autoShipEnabled) setOpen(false);else setOpen(true);
  };

  return React__default.createElement(React__default.Fragment, null, (flags === null || flags === void 0 ? void 0 : flags.blackFriday2020Sale) && React__default.createElement(BlackFridaySaleDialog, {
    onClose: handleCloseDialog,
    open: open
  }), React__default.createElement(FormControl, null, React__default.createElement(CheckButton, {
    disableRipple: true,
    color: "default",
    onChange: handleChange,
    checked: autoShipEnabled,
    icon: React__default.createElement(RadioButtonUncheckedIcon, null),
    checkedIcon: React__default.createElement(CheckCircleIcon$1, null)
  })));
}

var _templateObject$8, _templateObject2$4;
var cssConstants$4 = styles.cssConstants;
var Select = /*#__PURE__*/styled(MuiSelect)(_templateObject$8 || (_templateObject$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 19px;\n    font-family: ", ";\n  }\n  .MuiInputBase-input {\n    background-color: #ffffff;\n    height: 48px;\n    padding: 0 16px;\n  }\n  &.MuiInput-underline:after,\n  &.MuiInput-underline:before {\n    border-bottom: 2px solid ", ";\n  }\n  &.Mui-focused {\n    background-color: #ffffff;\n    opacity: 1 !important;\n  }\n  .MuiSvgIcon-root {\n    fill: ", ";\n  }\n"])), cssConstants$4.tertiaryFont, cssConstants$4.primaryColor, cssConstants$4.primaryColor);
var Label = /*#__PURE__*/styled.div(_templateObject2$4 || (_templateObject2$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 11px;\n  line-height: 16px;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.01em;\n  color: #4f5153;\n  padding: 4px;\n"])), cssConstants$4.tertiaryFont);
function AutoShipFrequency() {
  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      user = _useCartNetworkLayerV.user,
      handleAutoshipCount = _useCartNetworkLayerV.handleAutoshipCount,
      seasonalWineClubDateGate = _useCartNetworkLayerV.seasonalWineClubDateGate;

  var _useCartContextValue = useCartContextValue(),
      autoShipIntervalCount = _useCartContextValue[0].autoShipIntervalCount,
      dispatch = _useCartContextValue[1];

  var defaultIntervalCount = 3; // sync displayed value to cart on load if autoshipIntervalCount is null

  useEffect(function () {
    if (!autoShipIntervalCount) {
      handleAutoshipCount(user.cartV2, defaultIntervalCount);
      dispatch({
        type: TypeKeys.UPDATE_AUTOSHIP_COUNT,
        autoShipIntervalCount: defaultIntervalCount
      });
    }
  }, []);

  var handleChange = function handleChange(event) {
    var updatedFrequency = Number(event.target.value);

    if (updatedFrequency !== autoShipIntervalCount) {
      handleAutoshipCount(user.cartV2, updatedFrequency);
      dispatch({
        type: TypeKeys.UPDATE_AUTOSHIP_COUNT,
        autoShipIntervalCount: updatedFrequency
      });
    }
  };

  return React__default.createElement(FormControl, null, React__default.createElement(Label, null, "Frequency"), React__default.createElement(Select, {
    "native": true,
    value: autoShipIntervalCount || defaultIntervalCount,
    onChange: handleChange
  }, React__default.createElement("option", {
    value: 1
  }, "Every Month"), React__default.createElement("option", {
    value: 2
  }, "Every 2 Months"), React__default.createElement("option", {
    value: 3
  }, "Every 3 Months"), !seasonalWineClubDateGate && React__default.createElement("option", {
    value: 4
  }, "Every 4 Months")));
}

var _templateObject$9, _templateObject2$5, _templateObject3$4, _templateObject4$4, _templateObject5$3, _templateObject6$2, _templateObject7$2, _templateObject8$2, _templateObject9$2, _templateObject10$1, _templateObject11;
var cssConstants$5 = styles.cssConstants;
var Dialog$1 = /*#__PURE__*/styled(MuiDialog)(_templateObject$9 || (_templateObject$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    z-index: 10002 !important;\n    font-family: ", ";\n  }\n"])), cssConstants$5.tertiaryFont);
var CloseButtonContainer = /*#__PURE__*/styled.div(_templateObject2$5 || (_templateObject2$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 16px 0 16px;\n"])));
var IconButton$1 = /*#__PURE__*/styled(MuiIconButton)(_templateObject3$4 || (_templateObject3$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &.MuiIconButton-root {\n    padding: 3px !important;\n    border-radius: 50% !important;\n  }\n  .MuiSvgIcon-root {\n    width: 1.2em;\n    height: 1.2em;\n    color: black;\n  }\n"])));
var DetailsText = /*#__PURE__*/styled.span(_templateObject4$4 || (_templateObject4$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: bold;\n  font-size: 14px;\n  text-decoration-line: underline;\n  &:hover {\n    cursor: pointer;\n  }\n  margin-left: 4px;\n"])));
var DialogContainer = /*#__PURE__*/styled.div(_templateObject5$3 || (_templateObject5$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 16px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]))); // const FreeShippingImg = styled(FreeShippingSvg)``;

var Headline = /*#__PURE__*/styled.span(_templateObject6$2 || (_templateObject6$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 32px;\n  font-weight: bold;\n  line-height: 1.34;\n  letter-spacing: -0.5px;\n  color: ", ";\n  text-align: center;\n"])), cssConstants$5.primaryColor, cssConstants$5.primaryColor);
var BodyContainer = /*#__PURE__*/styled.div(_templateObject7$2 || (_templateObject7$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  min-height: 255px;\n  font-size: 14px;\n  line-height: 1.43;\n  color: ", ";\n  padding: 30px;\n"])), cssConstants$5.textColor);
var BodyItems = /*#__PURE__*/styled.div(_templateObject8$2 || (_templateObject8$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding-bottom: 15px;\n  padding-top: 5px;\n"])));
var SubText = /*#__PURE__*/styled.div(_templateObject9$2 || (_templateObject9$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 10px 0;\n  font-size: 10px;\n"])));
var Buttons = /*#__PURE__*/styled.div(_templateObject10$1 || (_templateObject10$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-bottom: 24px;\n"])));
var Link = /*#__PURE__*/styled.a(_templateObject11 || (_templateObject11 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: ", ";\n"])), cssConstants$5.linkColor);
function DetailsModal() {
  var theme = useTheme();
  var fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      flags = _useCartNetworkLayerV.flags;

  var _useCartContextValue = useCartContextValue(),
      state = _useCartContextValue[0];

  var _React$useState = React__default.useState(false),
      openDetails = _React$useState[0],
      setOpen = _React$useState[1];

  var handleClickOpen = function handleClickOpen() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  }; // Promotion: Free PC membership with subscription


  var showPromoText = !state.isUserPc && flags && flags.freePcWithSubscription;
  var headerText = showPromoText ? React__default.createElement("span", null, "Subscribe for a FREE membership", React__default.createElement("br", null), "and FREE shipping!") : React__default.createElement(React__default.Fragment, null, React__default.createElement("div", null, "Get FREE shipping"), React__default.createElement("div", null, "with a subscription!"));
  var promoBodyItems = showPromoText ? React__default.createElement(BodyItems, null, "*For a limited time, get your first year of Preferred Customer membership free when you subscribe.") : null;
  var promoSubText = showPromoText ? React__default.createElement(React__default.Fragment, null, ' ', "Free Preferred Customer membership with subscription is a limited-time promotion and only applies to the first year of membership. A standard $19.99 fee will apply after the first year.") : null;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(DetailsText, {
    onClick: handleClickOpen
  }, "Details"), openDetails && React__default.createElement(Dialog$1, {
    fullScreen: fullScreen,
    open: openDetails,
    onClose: handleClose,
    "aria-labelledby": 'removePc-dialog'
  }, React__default.createElement(CloseButtonContainer, null, React__default.createElement(IconButton$1, {
    "aria-label": 'close',
    onClick: handleClose
  }, React__default.createElement(CloseIcon$1, null))), React__default.createElement(DialogContainer, null, React__default.createElement(Headline, null, headerText), React__default.createElement(BodyContainer, null, React__default.createElement(BodyItems, null, "*Wine delivered to my door? YES please! Select \u201CYes\u201D to turn your 4, 6 or 12 pack into a recurring subscription and receive the best deal yet: FREE shipping! ($10 savings!)"), React__default.createElement(BodyItems, null, "*Pick a frequency (1, 2, 3, or 4 months) and your subscription will automatically ship based on your choice. We\u2019ll send an email prior to each shipment so you can easily swap wines and track your order!"), React__default.createElement(BodyItems, null, "*Earn rewards double the rewards points when you subscribe that can be redeemed for discounts on our award-winning wines, or donated to a cause you\u2019re passionate about."), React__default.createElement(BodyItems, null, "*If you\u2019re happy, we\u2019re happy!! Rest assured that ONEHOPE subscriptions can be changed or cancelled at any time by contacting us at", ' ', React__default.createElement(Link, {
    href: 'mailto:support@onehopewine.com'
  }, "support@onehopewine.com"), ".", ' '), promoBodyItems, React__default.createElement(SubText, null, "*Please note: In order to receive free shipping you must commit to a minimum of 2 subscription shipments. If you choose to cancel prior to your 2nd shipment, a $10 charge will be issued.", promoSubText)), React__default.createElement(Buttons, null, React__default.createElement(MuiButton, {
    style: {
      width: 288
    },
    // @ts-ignore
    type: 'PRIMARY',
    onClick: handleClose
  }, "Ok, sounds good!")))));
}

var _templateObject$a, _templateObject2$6, _templateObject3$5, _templateObject4$5, _templateObject5$4, _templateObject6$3;
var cssConstants$6 = styles.cssConstants;
var Dialog$2 = /*#__PURE__*/styled(MuiDialog)(_templateObject$a || (_templateObject$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    z-index: 10002 !important;\n    font-family: ", ";\n  }\n"])), cssConstants$6.tertiaryFont);
var DialogContent = /*#__PURE__*/withStyles(function () {
  return {
    root: {
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      maxWidth: '320px'
    }
  };
})(MuiDialogContent);
var Button = /*#__PURE__*/styled(MuiButton)(_templateObject2$6 || (_templateObject2$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    font-family: ", ";\n    height: 40px;\n    width: 240px;\n    margin: 24px;\n  }\n"])), cssConstants$6.tertiaryFont);
var CloseButtonContainer$1 = /*#__PURE__*/styled.div(_templateObject3$5 || (_templateObject3$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 16px 0 16px;\n"])));
var IconButton$2 = /*#__PURE__*/styled(MuiIconButton)(_templateObject4$5 || (_templateObject4$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &.MuiIconButton-root {\n    padding: 3px !important;\n    border-radius: 50% !important;\n  }\n  .MuiSvgIcon-root {\n    width: 1.2em;\n    height: 1.2em;\n    color: black;\n  }\n"])));
var Header$1 = /*#__PURE__*/styled.div(_templateObject5$4 || (_templateObject5$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-size: 32px;\n  font-weight: bold;\n  text-align: center;\n"])), cssConstants$6.italicFont);
var Summary = /*#__PURE__*/styled.div(_templateObject6$3 || (_templateObject6$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  padding: 8px 16px;\n  text-align: center;\n  //@media only screen and (min-width: 768px) {\n  //  padding: 8px 64px;\n  //}\n"])), cssConstants$6.tertiaryFont);
function PCSaleSubscriptionDialog() {
  var _useCartContextValue = useCartContextValue(),
      pCSaleSubscriptionDialogOpen = _useCartContextValue[0].pCSaleSubscriptionDialogOpen,
      dispatch = _useCartContextValue[1];

  var handleClose = function handleClose() {
    dispatch({
      type: TypeKeys.UPDATE_PC_SALE_SUBSCRIPTION_DIALOG,
      pCSaleSubscriptionDialogOpen: false
    });
  };

  return createElement(Dialog$2, {
    onClose: handleClose,
    "aria-labelledby": 'PCSaleSubscription-dialog',
    open: !!pCSaleSubscriptionDialogOpen
  }, createElement(CloseButtonContainer$1, null, createElement(IconButton$2, {
    "aria-label": 'close',
    onClick: handleClose
  }, createElement(CloseIcon$1, null))), createElement(DialogContent, null, createElement(FYISvg, null), createElement(Header$1, null, "Heads up!"), createElement(Summary, null, "The wine you are ordering today is specially priced for a limited-time promotion. Your future subscription shipments will be priced according to our standard Preferred Customer discounts of 5% of 4 bottles, 10% off 6 bottles, and 20% off 12 bottles."), createElement(Button // @ts-ignore
  , {
    // @ts-ignore
    type: 'PRIMARY',
    onClick: handleClose
  }, "Ok, sounds good")));
}

var _templateObject$b, _templateObject2$7, _templateObject3$6;
var cssConstants$7 = styles.cssConstants;
var AutoShipUpsellContainer = /*#__PURE__*/styled.div(_templateObject$b || (_templateObject$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  padding: 16px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 21px;\n  letter-spacing: 0.01em;\n  color: ", ";\n  font-family: ", ";\n  margin-bottom: 16px;\n  border: 1px solid ", ";\n"])), cssConstants$7.bronzeNeutral6, cssConstants$7.primaryColor, cssConstants$7.tertiaryFont, cssConstants$7.bronzeNeutral5);
var SubscriberInfoContainer = /*#__PURE__*/styled.div(_templateObject2$7 || (_templateObject2$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n"])));
var FreeShippingText = /*#__PURE__*/styled.div(_templateObject3$6 || (_templateObject3$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: ", ";\n  padding: 8px 0;\n"])), cssConstants$7.bronzeNeutral5);
function AutoShipUpsell() {
  var unsubscribedText = 'Subscribe to this order & join the Wine Club for FREE shipping and 10% back in points!';
  var subscribedText = "Yes, subscribe me to this order, and join the Wine Club!";
  var freeShippingText = "Get FREE shipping and 10% back in points";

  var _useCartContextValue = useCartContextValue(),
      autoShipEnabled = _useCartContextValue[0].autoShipEnabled;

  var text = autoShipEnabled ? subscribedText : unsubscribedText;
  return React__default.createElement(AutoShipUpsellContainer, {
    autoShipEnabled: autoShipEnabled
  }, React__default.createElement(PCSaleSubscriptionDialog, null), React__default.createElement(SubscriberInfoContainer, null, React__default.createElement("span", null, text, React__default.createElement(DetailsModal, null)), React__default.createElement(CheckboxContainer, null)), autoShipEnabled && React__default.createElement(FreeShippingText, {
    dangerouslySetInnerHTML: {
      __html: freeShippingText
    }
  }), autoShipEnabled && React__default.createElement(AutoShipFrequency, null));
}

var _templateObject$c, _templateObject2$8, _templateObject3$7, _templateObject4$6;
var cssConstants$8 = styles.cssConstants;
var KeepShoppingButton = /*#__PURE__*/styled(MuiButton)(_templateObject$c || (_templateObject$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    margin-top: 24px;\n    height: 44px !important;\n    border-radius: 0 !important;\n    font-style: normal;\n    font-weight: 300 !important;\n    font-size: 12px !important;\n    line-height: 16px !important;\n    font-family: ", " !important;\n    letter-spacing: 0.1em !important;\n    background-color: ", " !important;\n  }\n"])), cssConstants$8.tertiaryFont, cssConstants$8.mudNeutral0);
var EmptyCartContainer = /*#__PURE__*/styled.div(_templateObject2$8 || (_templateObject2$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 32px;\n  line-height: 44px;\n  color: ", ";\n  text-align: center;\n  letter-spacing: 0.0005em;\n  padding: 100px 0;\n"])), cssConstants$8.tertiaryFont, cssConstants$8.mudNeutral0);
var Header$2 = /*#__PURE__*/styled.div(_templateObject3$7 || (_templateObject3$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-weight: 300;\n  font-size: 24px;\n  line-height: 36px;\n  /* identical to box height */\n  text-align: center;\n  letter-spacing: 0.04em;\n  font-family: ", ";\n"])), cssConstants$8.italicFont);
var Subheader = /*#__PURE__*/styled.div(_templateObject4$6 || (_templateObject4$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ont-weight: bold;\n  font-size: 14px;\n  line-height: 21px;\n  color: ", ";\n  text-align: center;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n"])), cssConstants$8.primaryColor);
function EmptyCart() {
  var emojiText = 'Oh no!️';
  var text = 'Your cart is empty.';

  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      toggleCartClosed = _useCartNetworkLayerV.toggleCartClosed;

  return React__default.createElement(EmptyCartContainer, null, React__default.createElement(Subheader, null, emojiText), React__default.createElement(Header$2, null, text), React__default.createElement(KeepShoppingButton, {
    fullWidth: true,
    onClick: toggleCartClosed
  }, "KEEP SHOPPING"));
}

var _templateObject$d, _templateObject2$9, _templateObject3$8, _templateObject4$7;

var cssConstants$9 = styles.cssConstants;
var Container = /*#__PURE__*/styled.div(_templateObject$d || (_templateObject$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-family: ", ";\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 11px;\n  line-height: 18px;\n  letter-spacing: 0.01em;\n  margin-bottom: 5px;\n"])), cssConstants$9.tertiaryFont);
var BronzeText = /*#__PURE__*/styled.span(_templateObject2$9 || (_templateObject2$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: ", ";\n"])), cssConstants$9.mudNeutral0);
var BlackText = /*#__PURE__*/styled.span(_templateObject3$8 || (_templateObject3$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: ", ";\n"])), cssConstants$9.primaryColor);
var PcPotentialSavingsText = /*#__PURE__*/styled.span(_templateObject4$7 || (_templateObject4$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: ", ";\n  text-align: center;\n"])), cssConstants$9.primaryColor);

var getPercentagePotentialSavings = function getPercentagePotentialSavings(cartTotal, bottleDiscount4, bottleDiscount6, bottleDiscount12) {
  return cartTotal < 4 ? bottleDiscount4 : cartTotal >= 6 ? bottleDiscount12 : bottleDiscount6;
};

var getSavingsText = function getSavingsText(actualSavings, pcPotentialSavings, addMoreQuantity, bottleDiscount12) {
  return pcPotentialSavings && pcPotentialSavings > 0 ? "You saved $" + (actualSavings === null || actualSavings === void 0 ? void 0 : actualSavings.toFixed(2)) + "! " : addMoreQuantity < 4 ? "Add " + addMoreQuantity + " more " : "Save up to " + bottleDiscount12 + "% ";
};

var getAddMoreText = function getAddMoreText(pcPotentialSavings, addMoreQuantity, percentagePotentialSavings, qualifiedCartTotal) {
  return pcPotentialSavings && pcPotentialSavings > 0 ? "Add " + addMoreQuantity + " more to save " + (qualifiedCartTotal < 12 ? '' : 'another') + " " + percentagePotentialSavings + "%!" : addMoreQuantity < 4 ? "to save " + percentagePotentialSavings + "% and get 1/2 off shipping!" : "and get 1/2 off shipping! ";
};

function PCSavingsText(props) {
  var discountQualifiedCartTotal = props.discountQualifiedCartTotal,
      promoCodeSavings = props.promoCodeSavings,
      bottleDiscount4 = props.bottleDiscount4,
      bottleDiscount6 = props.bottleDiscount6,
      bottleDiscount12 = props.bottleDiscount12;
  var cartTotal = discountQualifiedCartTotal % 12;
  var pcPotentialSavings = promoCodeSavings || 0;
  var actualSavings = promoCodeSavings;
  var addMoreQuantity = cartTotal < 4 ? 4 - cartTotal : cartTotal < 6 ? 6 - cartTotal : 12 - cartTotal;
  var percentagePotentialSavings = getPercentagePotentialSavings(cartTotal, bottleDiscount4, bottleDiscount6, bottleDiscount12);
  var savingsText = getSavingsText(actualSavings, pcPotentialSavings, addMoreQuantity, bottleDiscount12);
  var addMoreText = getAddMoreText(pcPotentialSavings, addMoreQuantity, percentagePotentialSavings, discountQualifiedCartTotal);
  return React__default.createElement(Container, null, React__default.createElement(PcPotentialSavingsText, null, React__default.createElement(BronzeText, null, savingsText), discountQualifiedCartTotal < 12 && React__default.createElement(BlackText, null, addMoreText)));
}

function BottleBack() {
  return React__default.createElement("svg", {
    width: '15',
    height: '36',
    viewBox: '0 0 15 36',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React__default.createElement("path", {
    d: 'M13.9903 20.1004C13.6782 18.3364 12.4353 15.714 12.1699 15.12C11.9045 14.5256 10.1791 11.202 9.74849 9.2296C9.36887 7.488 9.15011 2.882 9.12598 2.3536C9.12437 2.3208 9.1351 2.2892 9.15708 2.2608L9.1796 2.2316C9.21552 2.1848 9.22089 2.128 9.19354 2.078C9.16512 2.0264 9.17155 1.968 9.2107 1.9204L9.3989 1.6912C9.42785 1.656 9.43911 1.614 9.43053 1.5732L9.35493 1.2068C9.3485 1.176 9.33134 1.1468 9.30453 1.1228L9.22678 1.0516C9.1855 1.0136 9.16727 0.9652 9.17638 0.9168C9.19676 0.8044 9.22303 0.584 9.1603 0.3968C9.07826 0.152 8.99622 0.134 8.7737 0.0280001C8.73671 0.00920007 8.69274 0 8.64824 0H7.20589H5.86703C5.82253 0 5.7791 0.00919994 5.74156 0.0271999C5.51905 0.1336 5.43701 0.1516 5.35497 0.396C5.29224 0.5832 5.31851 0.8036 5.33889 0.916C5.348 0.9644 5.32977 1.0132 5.28848 1.0508L5.21074 1.122C5.18446 1.1464 5.16677 1.1752 5.16034 1.206L5.08473 1.5724C5.07615 1.6132 5.08741 1.6552 5.11637 1.6904L5.30457 1.92C5.34371 1.9676 5.35015 2.026 5.32173 2.0776C5.29438 2.1276 5.29921 2.1844 5.33567 2.2312L5.35819 2.2604C5.38017 2.2888 5.3909 2.3208 5.38929 2.3532C5.36516 2.8816 5.14693 7.4876 4.76677 9.2292C4.33675 11.2016 2.6113 14.5256 2.34535 15.1196C2.07994 15.714 0.837055 18.3364 0.524993 20.1C0.200064 21.9344 0.231162 28.6856 0.309446 29.7112C0.367354 30.468 0.313199 33.7632 0.410785 34.6412C0.458506 35.0684 0.712123 35.3616 0.830084 35.4588C1.41292 35.938 7.19249 36 7.19249 36C7.19249 36 13.1023 35.938 13.6846 35.4592C13.8026 35.3624 14.0562 35.0688 14.1039 34.6416C14.2021 33.7636 14.1474 30.4684 14.2053 29.7116C14.2841 28.686 14.3152 21.9348 13.9903 20.1004Z',
    fill: '#393939'
  }));
}

function BottleBlue() {
  return React__default.createElement("svg", {
    width: '15',
    height: '36',
    viewBox: '0 0 15 36',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React__default.createElement("path", {
    d: 'M13.9881 20.1004C13.676 18.3364 12.4331 15.714 12.1677 15.12C11.9023 14.5256 10.1769 11.202 9.7463 9.2296C9.36668 7.488 9.14791 2.882 9.12378 2.3536C9.12218 2.3208 9.1329 2.2892 9.15488 2.2608L9.1774 2.2316C9.21333 2.1848 9.21869 2.128 9.19134 2.078C9.16292 2.0264 9.16936 1.968 9.2085 1.9204L9.3967 1.6912C9.42566 1.656 9.43692 1.614 9.42834 1.5732L9.35273 1.2068C9.3463 1.176 9.32914 1.1468 9.30233 1.1228L9.22459 1.0516C9.1833 1.0136 9.16507 0.9652 9.17418 0.9168C9.19456 0.8044 9.22083 0.584 9.1581 0.3968C9.07606 0.152 8.99403 0.134 8.77151 0.0280001C8.73451 0.00920007 8.69054 0 8.64604 0H7.20369H5.86483C5.82033 0 5.7769 0.00919994 5.73937 0.0271999C5.51685 0.1336 5.43481 0.1516 5.35277 0.396C5.29004 0.5832 5.31631 0.8036 5.33669 0.916C5.3458 0.9644 5.32757 1.0132 5.28629 1.0508L5.20854 1.122C5.18227 1.1464 5.16457 1.1752 5.15814 1.206L5.08254 1.5724C5.07396 1.6132 5.08522 1.6552 5.11417 1.6904L5.30237 1.92C5.34151 1.9676 5.34795 2.026 5.31953 2.0776C5.29219 2.1276 5.29701 2.1844 5.33347 2.2312L5.35599 2.2604C5.37798 2.2888 5.3887 2.3208 5.38709 2.3532C5.36296 2.8816 5.14473 7.4876 4.76458 9.2292C4.33455 11.2016 2.6091 14.5256 2.34315 15.1196C2.07774 15.714 0.834857 18.3364 0.522796 20.1C0.197866 21.9344 0.228965 28.6856 0.307249 29.7112C0.365157 30.468 0.311001 33.7632 0.408588 34.6412C0.456308 35.0684 0.709926 35.3616 0.827887 35.4588C1.41072 35.938 7.19029 36 7.19029 36C7.19029 36 13.1002 35.938 13.6825 35.4592C13.8004 35.3624 14.054 35.0688 14.1018 34.6416C14.1999 33.7636 14.1452 30.4684 14.2031 29.7116C14.2819 28.686 14.313 21.9348 13.9881 20.1004Z',
    fill: '#46789E'
  }));
}

function BottleBlue4() {
  return React__default.createElement("svg", {
    width: "14",
    height: "36",
    viewBox: "0 0 14 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    d: "M13.7327 20.1004C13.4206 18.3364 12.1778 15.714 11.9123 15.12C11.6469 14.5256 9.92148 11.202 9.49093 9.2296C9.1113 7.488 8.89254 2.882 8.86841 2.3536C8.8668 2.3208 8.87753 2.2892 8.89951 2.2608L8.92203 2.2316C8.95795 2.1848 8.96332 2.128 8.93597 2.078C8.90755 2.0264 8.91399 1.968 8.95313 1.9204L9.14133 1.6912C9.17029 1.656 9.18154 1.614 9.17297 1.5732L9.09736 1.2068C9.09093 1.176 9.07377 1.1468 9.04696 1.1228L8.96922 1.0516C8.92793 1.0136 8.9097 0.9652 8.91881 0.9168C8.93919 0.8044 8.96546 0.584 8.90273 0.3968C8.82069 0.152 8.73865 0.134 8.51614 0.0280001C8.47914 0.00920007 8.43517 0 8.39067 0H6.94832H5.60946C5.56496 0 5.52153 0.00919994 5.484 0.0271999C5.26148 0.1336 5.17944 0.1516 5.0974 0.396C5.03467 0.5832 5.06094 0.8036 5.08132 0.916C5.09043 0.9644 5.0722 1.0132 5.03092 1.0508L4.95317 1.122C4.9269 1.1464 4.9092 1.1752 4.90277 1.206L4.82716 1.5724C4.81859 1.6132 4.82985 1.6552 4.8588 1.6904L5.047 1.92C5.08614 1.9676 5.09258 2.026 5.06416 2.0776C5.03681 2.1276 5.04164 2.1844 5.0781 2.2312L5.10062 2.2604C5.1226 2.2888 5.13333 2.3208 5.13172 2.3532C5.10759 2.8816 4.88936 7.4876 4.50921 9.2292C4.07918 11.2016 2.35373 14.5256 2.08778 15.1196C1.82237 15.714 0.579486 18.3364 0.267425 20.1C-0.0575046 21.9344 -0.026406 28.6856 0.0518774 29.7112C0.109786 30.468 0.0556303 33.7632 0.153216 34.6412C0.200937 35.0684 0.454555 35.3616 0.572516 35.4588C1.15535 35.938 6.93492 36 6.93492 36C6.93492 36 12.8448 35.938 13.4271 35.4592C13.545 35.3624 13.7987 35.0688 13.8464 34.6416C13.9445 33.7636 13.8898 30.4684 13.9477 29.7116C14.0265 28.686 14.0576 21.9348 13.7327 20.1004Z",
    fill: "#46789E"
  }), React__default.createElement("path", {
    d: "M3.86336 28.212H7.77536V29.772C7.77536 29.892 7.88336 30 8.00336 30H8.71136C8.83136 30 8.93936 29.892 8.93936 29.772L8.92736 28.188H9.89936C10.0314 28.188 10.1274 28.08 10.1274 27.96V27.456C10.1274 27.336 10.0314 27.24 9.89936 27.24H8.92736V21.936C8.92736 21.804 8.81936 21.708 8.69936 21.708H8.25536C8.20736 21.708 8.11136 21.744 8.07536 21.78L3.63536 27.264V27.984C3.63536 28.104 3.73136 28.212 3.86336 28.212ZM4.93136 27.216L7.82336 23.688V27.216H4.93136Z",
    fill: "white"
  }));
}

function BottleBlue6() {
  return React__default.createElement("svg", {
    width: '14',
    height: '36',
    viewBox: '0 0 14 36',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React__default.createElement("path", {
    d: 'M13.7327 20.1004C13.4206 18.3364 12.1778 15.714 11.9123 15.12C11.6469 14.5256 9.92148 11.202 9.49093 9.2296C9.1113 7.488 8.89254 2.882 8.86841 2.3536C8.8668 2.3208 8.87753 2.2892 8.89951 2.2608L8.92203 2.2316C8.95795 2.1848 8.96332 2.128 8.93597 2.078C8.90755 2.0264 8.91399 1.968 8.95313 1.9204L9.14133 1.6912C9.17029 1.656 9.18154 1.614 9.17297 1.5732L9.09736 1.2068C9.09093 1.176 9.07377 1.1468 9.04696 1.1228L8.96922 1.0516C8.92793 1.0136 8.9097 0.9652 8.91881 0.9168C8.93919 0.8044 8.96546 0.584 8.90273 0.3968C8.82069 0.152 8.73865 0.134 8.51614 0.0280001C8.47914 0.00920007 8.43517 0 8.39067 0H6.94832H5.60946C5.56496 0 5.52153 0.00919994 5.484 0.0271999C5.26148 0.1336 5.17944 0.1516 5.0974 0.396C5.03467 0.5832 5.06094 0.8036 5.08132 0.916C5.09043 0.9644 5.0722 1.0132 5.03092 1.0508L4.95317 1.122C4.9269 1.1464 4.9092 1.1752 4.90277 1.206L4.82716 1.5724C4.81859 1.6132 4.82985 1.6552 4.8588 1.6904L5.047 1.92C5.08614 1.9676 5.09258 2.026 5.06416 2.0776C5.03681 2.1276 5.04164 2.1844 5.0781 2.2312L5.10062 2.2604C5.1226 2.2888 5.13333 2.3208 5.13172 2.3532C5.10759 2.8816 4.88936 7.4876 4.50921 9.2292C4.07918 11.2016 2.35373 14.5256 2.08778 15.1196C1.82237 15.714 0.579486 18.3364 0.267425 20.1C-0.0575046 21.9344 -0.026406 28.6856 0.0518774 29.7112C0.109786 30.468 0.0556303 33.7632 0.153216 34.6412C0.200937 35.0684 0.454555 35.3616 0.572516 35.4588C1.15535 35.938 6.93492 36 6.93492 36C6.93492 36 12.8448 35.938 13.4271 35.4592C13.545 35.3624 13.7987 35.0688 13.8464 34.6416C13.9445 33.7636 13.8898 30.4684 13.9477 29.7116C14.0265 28.686 14.0576 21.9348 13.7327 20.1004Z',
    fill: '#46789E'
  }), React__default.createElement("path", {
    d: 'M4.32991 26.76C4.32991 28.608 5.24191 30.12 7.16191 30.12C8.61391 30.12 9.83791 28.884 9.83791 27.372C9.83791 25.716 8.60191 24.768 7.32991 24.768C6.52591 24.768 5.82991 25.152 5.73391 25.212C6.12991 23.736 8.03791 22.74 8.58991 22.56C8.81791 22.488 8.86591 22.356 8.80591 22.212L8.60191 21.72C8.55391 21.588 8.44591 21.528 8.30191 21.576C7.19791 21.996 4.32991 23.412 4.32991 26.76ZM7.14991 29.04C5.84191 29.04 5.39791 27.672 5.49391 26.664C5.56591 26.448 6.18991 25.752 7.13791 25.752C8.02591 25.752 8.73391 26.484 8.73391 27.384C8.73391 28.284 8.03791 29.04 7.14991 29.04Z',
    fill: 'white'
  }));
}

function BottleBlue12() {
  return React__default.createElement("svg", {
    width: '14',
    height: '36',
    viewBox: '0 0 14 36',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React__default.createElement("path", {
    d: 'M13.7327 20.1004C13.4206 18.3364 12.1778 15.714 11.9123 15.12C11.6469 14.5256 9.92148 11.202 9.49093 9.2296C9.1113 7.488 8.89254 2.882 8.86841 2.3536C8.8668 2.3208 8.87753 2.2892 8.89951 2.2608L8.92203 2.2316C8.95795 2.1848 8.96332 2.128 8.93597 2.078C8.90755 2.0264 8.91399 1.968 8.95313 1.9204L9.14133 1.6912C9.17029 1.656 9.18154 1.614 9.17297 1.5732L9.09736 1.2068C9.09093 1.176 9.07377 1.1468 9.04696 1.1228L8.96922 1.0516C8.92793 1.0136 8.9097 0.9652 8.91881 0.9168C8.93919 0.8044 8.96546 0.584 8.90273 0.3968C8.82069 0.152 8.73865 0.134 8.51614 0.0280001C8.47914 0.00920007 8.43517 0 8.39067 0H6.94832H5.60946C5.56496 0 5.52153 0.00919994 5.484 0.0271999C5.26148 0.1336 5.17944 0.1516 5.0974 0.396C5.03467 0.5832 5.06094 0.8036 5.08132 0.916C5.09043 0.9644 5.0722 1.0132 5.03092 1.0508L4.95317 1.122C4.9269 1.1464 4.9092 1.1752 4.90277 1.206L4.82716 1.5724C4.81859 1.6132 4.82985 1.6552 4.8588 1.6904L5.047 1.92C5.08614 1.9676 5.09258 2.026 5.06416 2.0776C5.03681 2.1276 5.04164 2.1844 5.0781 2.2312L5.10062 2.2604C5.1226 2.2888 5.13333 2.3208 5.13172 2.3532C5.10759 2.8816 4.88936 7.4876 4.50921 9.2292C4.07918 11.2016 2.35373 14.5256 2.08778 15.1196C1.82237 15.714 0.579486 18.3364 0.267425 20.1C-0.0575046 21.9344 -0.026406 28.6856 0.0518774 29.7112C0.109786 30.468 0.0556303 33.7632 0.153216 34.6412C0.200937 35.0684 0.454555 35.3616 0.572516 35.4588C1.15535 35.938 6.93492 36 6.93492 36C6.93492 36 12.8448 35.938 13.4271 35.4592C13.545 35.3624 13.7987 35.0688 13.8464 34.6416C13.9445 33.7636 13.8898 30.4684 13.9477 29.7116C14.0265 28.686 14.0576 21.9348 13.7327 20.1004Z',
    fill: '#46789E'
  }), React__default.createElement("path", {
    d: 'M3.88989 29.772C3.88989 29.892 3.98589 30 4.11789 30H4.84989C4.96989 30 5.06589 29.892 5.06589 29.772V22.068C5.06589 21.948 4.96989 21.84 4.84989 21.84H4.26189L2.55789 23.388C2.50989 23.436 2.48589 23.532 2.52189 23.628L2.66589 24.048C2.70189 24.156 2.82189 24.18 2.92989 24.132L3.88989 23.676V29.772ZM6.08317 29.772C6.08317 29.892 6.17917 30 6.31117 30H10.9552C11.0752 30 11.1832 29.892 11.1832 29.772V29.196C11.1832 29.076 11.0752 28.968 10.9552 28.968H7.89517C8.60317 28.164 9.44317 27.18 10.0792 26.412C10.7272 25.632 11.2312 24.996 11.2312 24.072C11.2312 22.812 10.3192 21.72 8.60317 21.72C7.17517 21.72 6.27517 22.896 6.27517 22.896C6.19117 22.992 6.21517 23.136 6.28717 23.208L6.69517 23.616C6.79117 23.712 6.92317 23.712 7.01917 23.616C7.34317 23.268 7.88317 22.812 8.54317 22.812C9.59917 22.812 10.0192 23.508 10.0192 24.12C10.0192 24.6 9.70717 25.2 9.10717 25.872C8.21917 26.928 6.97117 28.452 6.08317 29.46V29.772Z',
    fill: 'white'
  }));
}

function BottleGray() {
  return React__default.createElement("svg", {
    width: '15',
    height: '36',
    viewBox: '0 0 15 36',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React__default.createElement("path", {
    d: 'M13.9903 20.1004C13.6782 18.3364 12.4353 15.714 12.1699 15.12C11.9045 14.5256 10.1791 11.202 9.74849 9.2296C9.36887 7.488 9.15011 2.882 9.12598 2.3536C9.12437 2.3208 9.1351 2.2892 9.15708 2.2608L9.1796 2.2316C9.21552 2.1848 9.22089 2.128 9.19354 2.078C9.16512 2.0264 9.17155 1.968 9.2107 1.9204L9.3989 1.6912C9.42785 1.656 9.43911 1.614 9.43053 1.5732L9.35493 1.2068C9.3485 1.176 9.33134 1.1468 9.30453 1.1228L9.22678 1.0516C9.1855 1.0136 9.16727 0.9652 9.17638 0.9168C9.19676 0.8044 9.22303 0.584 9.1603 0.3968C9.07826 0.152 8.99622 0.134 8.7737 0.0280001C8.73671 0.00920007 8.69274 0 8.64824 0H7.20589H5.86703C5.82253 0 5.7791 0.00919994 5.74156 0.0271999C5.51905 0.1336 5.43701 0.1516 5.35497 0.396C5.29224 0.5832 5.31851 0.8036 5.33889 0.916C5.348 0.9644 5.32977 1.0132 5.28848 1.0508L5.21074 1.122C5.18446 1.1464 5.16677 1.1752 5.16034 1.206L5.08473 1.5724C5.07615 1.6132 5.08741 1.6552 5.11637 1.6904L5.30457 1.92C5.34371 1.9676 5.35015 2.026 5.32173 2.0776C5.29438 2.1276 5.29921 2.1844 5.33567 2.2312L5.35819 2.2604C5.38017 2.2888 5.3909 2.3208 5.38929 2.3532C5.36516 2.8816 5.14693 7.4876 4.76677 9.2292C4.33675 11.2016 2.6113 14.5256 2.34535 15.1196C2.07994 15.714 0.837055 18.3364 0.524993 20.1C0.200064 21.9344 0.231162 28.6856 0.309446 29.7112C0.367354 30.468 0.313199 33.7632 0.410785 34.6412C0.458506 35.0684 0.712123 35.3616 0.830084 35.4588C1.41292 35.938 7.19249 36 7.19249 36C7.19249 36 13.1023 35.938 13.6846 35.4592C13.8026 35.3624 14.0562 35.0688 14.1039 34.6416C14.2021 33.7636 14.1474 30.4684 14.2053 29.7116C14.2841 28.686 14.3152 21.9348 13.9903 20.1004Z',
    fill: '#C2C6C9'
  }));
}

function BottleGray6() {
  return React__default.createElement("svg", {
    width: '16',
    height: '38',
    viewBox: '0 0 16 38',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React__default.createElement("path", {
    d: 'M14.7327 21.1004C14.4206 19.3364 13.1778 16.714 12.9123 16.12C12.6469 15.5256 10.9215 12.202 10.4909 10.2296C10.1113 8.488 9.89254 3.882 9.86841 3.3536C9.8668 3.3208 9.87753 3.2892 9.89951 3.2608L9.92203 3.2316C9.95795 3.1848 9.96332 3.128 9.93597 3.078C9.90755 3.0264 9.91399 2.968 9.95313 2.9204L10.1413 2.6912C10.1703 2.656 10.1815 2.614 10.173 2.5732L10.0974 2.2068C10.0909 2.176 10.0738 2.1468 10.047 2.1228L9.96922 2.0516C9.92793 2.0136 9.9097 1.9652 9.91881 1.9168C9.93919 1.8044 9.96546 1.584 9.90273 1.3968C9.82069 1.152 9.73865 1.134 9.51614 1.028C9.47914 1.0092 9.43517 1 9.39067 1H7.94832H6.60946C6.56496 1 6.52153 1.0092 6.484 1.0272C6.26148 1.1336 6.17944 1.1516 6.0974 1.396C6.03467 1.5832 6.06094 1.8036 6.08132 1.916C6.09043 1.9644 6.0722 2.0132 6.03092 2.0508L5.95317 2.122C5.9269 2.1464 5.9092 2.1752 5.90277 2.206L5.82716 2.5724C5.81859 2.6132 5.82985 2.6552 5.8588 2.6904L6.047 2.92C6.08614 2.9676 6.09258 3.026 6.06416 3.0776C6.03681 3.1276 6.04164 3.1844 6.0781 3.2312L6.10062 3.2604C6.1226 3.2888 6.13333 3.3208 6.13172 3.3532C6.10759 3.8816 5.88936 8.4876 5.50921 10.2292C5.07918 12.2016 3.35373 15.5256 3.08778 16.1196C2.82237 16.714 1.57949 19.3364 1.26743 21.1C0.942495 22.9344 0.973594 29.6856 1.05188 30.7112C1.10979 31.468 1.05563 34.7632 1.15322 35.6412C1.20094 36.0684 1.45455 36.3616 1.57252 36.4588C2.15535 36.938 7.93492 37 7.93492 37C7.93492 37 13.8448 36.938 14.4271 36.4592C14.545 36.3624 14.7987 36.0688 14.8464 35.6416C14.9445 34.7636 14.8898 31.4684 14.9477 30.7116C15.0265 29.686 15.0576 22.9348 14.7327 21.1004Z',
    fill: 'white',
    stroke: '#393939',
    strokeWidth: '0.75'
  }), React__default.createElement("path", {
    d: 'M5.32991 27.76C5.32991 29.608 6.24191 31.12 8.16191 31.12C9.61391 31.12 10.8379 29.884 10.8379 28.372C10.8379 26.716 9.60191 25.768 8.32991 25.768C7.52591 25.768 6.82991 26.152 6.73391 26.212C7.12991 24.736 9.03791 23.74 9.58991 23.56C9.81791 23.488 9.86591 23.356 9.80591 23.212L9.60191 22.72C9.55391 22.588 9.44591 22.528 9.30191 22.576C8.19791 22.996 5.32991 24.412 5.32991 27.76ZM8.14991 30.04C6.84191 30.04 6.39791 28.672 6.49391 27.664C6.56591 27.448 7.18991 26.752 8.13791 26.752C9.02591 26.752 9.73391 27.484 9.73391 28.384C9.73391 29.284 9.03791 30.04 8.14991 30.04Z',
    fill: '#393939'
  }));
}

function BottleGray12() {
  return React__default.createElement("svg", {
    width: '16',
    height: '38',
    viewBox: '0 0 16 38',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React__default.createElement("path", {
    d: 'M14.7327 21.1004C14.4206 19.3364 13.1778 16.714 12.9123 16.12C12.6469 15.5256 10.9215 12.202 10.4909 10.2296C10.1113 8.488 9.89254 3.882 9.86841 3.3536C9.8668 3.3208 9.87753 3.2892 9.89951 3.2608L9.92203 3.2316C9.95795 3.1848 9.96332 3.128 9.93597 3.078C9.90755 3.0264 9.91399 2.968 9.95313 2.9204L10.1413 2.6912C10.1703 2.656 10.1815 2.614 10.173 2.5732L10.0974 2.2068C10.0909 2.176 10.0738 2.1468 10.047 2.1228L9.96922 2.0516C9.92793 2.0136 9.9097 1.9652 9.91881 1.9168C9.93919 1.8044 9.96546 1.584 9.90273 1.3968C9.82069 1.152 9.73865 1.134 9.51614 1.028C9.47914 1.0092 9.43517 1 9.39067 1H7.94832H6.60946C6.56496 1 6.52153 1.0092 6.484 1.0272C6.26148 1.1336 6.17944 1.1516 6.0974 1.396C6.03467 1.5832 6.06094 1.8036 6.08132 1.916C6.09043 1.9644 6.0722 2.0132 6.03092 2.0508L5.95317 2.122C5.9269 2.1464 5.9092 2.1752 5.90277 2.206L5.82716 2.5724C5.81859 2.6132 5.82985 2.6552 5.8588 2.6904L6.047 2.92C6.08614 2.9676 6.09258 3.026 6.06416 3.0776C6.03681 3.1276 6.04164 3.1844 6.0781 3.2312L6.10062 3.2604C6.1226 3.2888 6.13333 3.3208 6.13172 3.3532C6.10759 3.8816 5.88936 8.4876 5.50921 10.2292C5.07918 12.2016 3.35373 15.5256 3.08778 16.1196C2.82237 16.714 1.57949 19.3364 1.26743 21.1C0.942495 22.9344 0.973594 29.6856 1.05188 30.7112C1.10979 31.468 1.05563 34.7632 1.15322 35.6412C1.20094 36.0684 1.45455 36.3616 1.57252 36.4588C2.15535 36.938 7.93492 37 7.93492 37C7.93492 37 13.8448 36.938 14.4271 36.4592C14.545 36.3624 14.7987 36.0688 14.8464 35.6416C14.9445 34.7636 14.8898 31.4684 14.9477 30.7116C15.0265 29.686 15.0576 22.9348 14.7327 21.1004Z',
    fill: 'white',
    stroke: '#393939',
    strokeWidth: '0.75'
  }), React__default.createElement("path", {
    d: 'M4.88989 30.772C4.88989 30.892 4.98589 31 5.11789 31H5.84989C5.96989 31 6.06589 30.892 6.06589 30.772V23.068C6.06589 22.948 5.96989 22.84 5.84989 22.84H5.26189L3.55789 24.388C3.50989 24.436 3.48589 24.532 3.52189 24.628L3.66589 25.048C3.70189 25.156 3.82189 25.18 3.92989 25.132L4.88989 24.676V30.772ZM7.08317 30.772C7.08317 30.892 7.17917 31 7.31117 31H11.9552C12.0752 31 12.1832 30.892 12.1832 30.772V30.196C12.1832 30.076 12.0752 29.968 11.9552 29.968H8.89517C9.60317 29.164 10.4432 28.18 11.0792 27.412C11.7272 26.632 12.2312 25.996 12.2312 25.072C12.2312 23.812 11.3192 22.72 9.60317 22.72C8.17517 22.72 7.27517 23.896 7.27517 23.896C7.19117 23.992 7.21517 24.136 7.28717 24.208L7.69517 24.616C7.79117 24.712 7.92317 24.712 8.01917 24.616C8.34317 24.268 8.88317 23.812 9.54317 23.812C10.5992 23.812 11.0192 24.508 11.0192 25.12C11.0192 25.6 10.7072 26.2 10.1072 26.872C9.21917 27.928 7.97117 29.452 7.08317 30.46V30.772Z',
    fill: '#393939'
  }));
}

function BottleBlack6() {
  return React__default.createElement("svg", {
    width: '16',
    height: '38',
    viewBox: '0 0 16 38',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React__default.createElement("path", {
    d: 'M14.7327 21.1004C14.4206 19.3364 13.1778 16.714 12.9123 16.12C12.6469 15.5256 10.9215 12.202 10.4909 10.2296C10.1113 8.488 9.89254 3.882 9.86841 3.3536C9.8668 3.3208 9.87753 3.2892 9.89951 3.2608L9.92203 3.2316C9.95795 3.1848 9.96332 3.128 9.93597 3.078C9.90755 3.0264 9.91399 2.968 9.95313 2.9204L10.1413 2.6912C10.1703 2.656 10.1815 2.614 10.173 2.5732L10.0974 2.2068C10.0909 2.176 10.0738 2.1468 10.047 2.1228L9.96922 2.0516C9.92793 2.0136 9.9097 1.9652 9.91881 1.9168C9.93919 1.8044 9.96546 1.584 9.90273 1.3968C9.82069 1.152 9.73865 1.134 9.51614 1.028C9.47914 1.0092 9.43517 1 9.39067 1H7.94832H6.60946C6.56496 1 6.52153 1.0092 6.484 1.0272C6.26148 1.1336 6.17944 1.1516 6.0974 1.396C6.03467 1.5832 6.06094 1.8036 6.08132 1.916C6.09043 1.9644 6.0722 2.0132 6.03092 2.0508L5.95317 2.122C5.9269 2.1464 5.9092 2.1752 5.90277 2.206L5.82716 2.5724C5.81859 2.6132 5.82985 2.6552 5.8588 2.6904L6.047 2.92C6.08614 2.9676 6.09258 3.026 6.06416 3.0776C6.03681 3.1276 6.04164 3.1844 6.0781 3.2312L6.10062 3.2604C6.1226 3.2888 6.13333 3.3208 6.13172 3.3532C6.10759 3.8816 5.88936 8.4876 5.50921 10.2292C5.07918 12.2016 3.35373 15.5256 3.08778 16.1196C2.82237 16.714 1.57949 19.3364 1.26743 21.1C0.942495 22.9344 0.973594 29.6856 1.05188 30.7112C1.10979 31.468 1.05563 34.7632 1.15322 35.6412C1.20094 36.0684 1.45455 36.3616 1.57252 36.4588C2.15535 36.938 7.93492 37 7.93492 37C7.93492 37 13.8448 36.938 14.4271 36.4592C14.545 36.3624 14.7987 36.0688 14.8464 35.6416C14.9445 34.7636 14.8898 31.4684 14.9477 30.7116C15.0265 29.686 15.0576 22.9348 14.7327 21.1004Z',
    fill: 'white',
    stroke: '#393939',
    strokeWidth: '0.75'
  }), React__default.createElement("path", {
    d: 'M5.32991 27.76C5.32991 29.608 6.24191 31.12 8.16191 31.12C9.61391 31.12 10.8379 29.884 10.8379 28.372C10.8379 26.716 9.60191 25.768 8.32991 25.768C7.52591 25.768 6.82991 26.152 6.73391 26.212C7.12991 24.736 9.03791 23.74 9.58991 23.56C9.81791 23.488 9.86591 23.356 9.80591 23.212L9.60191 22.72C9.55391 22.588 9.44591 22.528 9.30191 22.576C8.19791 22.996 5.32991 24.412 5.32991 27.76ZM8.14991 30.04C6.84191 30.04 6.39791 28.672 6.49391 27.664C6.56591 27.448 7.18991 26.752 8.13791 26.752C9.02591 26.752 9.73391 27.484 9.73391 28.384C9.73391 29.284 9.03791 30.04 8.14991 30.04Z',
    fill: '#393939'
  }));
}

function BottleBlack12() {
  return React__default.createElement("svg", {
    width: '16',
    height: '38',
    viewBox: '0 0 16 38',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React__default.createElement("path", {
    d: 'M14.7327 21.1004C14.4206 19.3364 13.1778 16.714 12.9123 16.12C12.6469 15.5256 10.9215 12.202 10.4909 10.2296C10.1113 8.488 9.89254 3.882 9.86841 3.3536C9.8668 3.3208 9.87753 3.2892 9.89951 3.2608L9.92203 3.2316C9.95795 3.1848 9.96332 3.128 9.93597 3.078C9.90755 3.0264 9.91399 2.968 9.95313 2.9204L10.1413 2.6912C10.1703 2.656 10.1815 2.614 10.173 2.5732L10.0974 2.2068C10.0909 2.176 10.0738 2.1468 10.047 2.1228L9.96922 2.0516C9.92793 2.0136 9.9097 1.9652 9.91881 1.9168C9.93919 1.8044 9.96546 1.584 9.90273 1.3968C9.82069 1.152 9.73865 1.134 9.51614 1.028C9.47914 1.0092 9.43517 1 9.39067 1H7.94832H6.60946C6.56496 1 6.52153 1.0092 6.484 1.0272C6.26148 1.1336 6.17944 1.1516 6.0974 1.396C6.03467 1.5832 6.06094 1.8036 6.08132 1.916C6.09043 1.9644 6.0722 2.0132 6.03092 2.0508L5.95317 2.122C5.9269 2.1464 5.9092 2.1752 5.90277 2.206L5.82716 2.5724C5.81859 2.6132 5.82985 2.6552 5.8588 2.6904L6.047 2.92C6.08614 2.9676 6.09258 3.026 6.06416 3.0776C6.03681 3.1276 6.04164 3.1844 6.0781 3.2312L6.10062 3.2604C6.1226 3.2888 6.13333 3.3208 6.13172 3.3532C6.10759 3.8816 5.88936 8.4876 5.50921 10.2292C5.07918 12.2016 3.35373 15.5256 3.08778 16.1196C2.82237 16.714 1.57949 19.3364 1.26743 21.1C0.942495 22.9344 0.973594 29.6856 1.05188 30.7112C1.10979 31.468 1.05563 34.7632 1.15322 35.6412C1.20094 36.0684 1.45455 36.3616 1.57252 36.4588C2.15535 36.938 7.93492 37 7.93492 37C7.93492 37 13.8448 36.938 14.4271 36.4592C14.545 36.3624 14.7987 36.0688 14.8464 35.6416C14.9445 34.7636 14.8898 31.4684 14.9477 30.7116C15.0265 29.686 15.0576 22.9348 14.7327 21.1004Z',
    fill: 'white',
    stroke: '#393939',
    strokeWidth: '0.75'
  }), React__default.createElement("path", {
    d: 'M4.88989 30.772C4.88989 30.892 4.98589 31 5.11789 31H5.84989C5.96989 31 6.06589 30.892 6.06589 30.772V23.068C6.06589 22.948 5.96989 22.84 5.84989 22.84H5.26189L3.55789 24.388C3.50989 24.436 3.48589 24.532 3.52189 24.628L3.66589 25.048C3.70189 25.156 3.82189 25.18 3.92989 25.132L4.88989 24.676V30.772ZM7.08317 30.772C7.08317 30.892 7.17917 31 7.31117 31H11.9552C12.0752 31 12.1832 30.892 12.1832 30.772V30.196C12.1832 30.076 12.0752 29.968 11.9552 29.968H8.89517C9.60317 29.164 10.4432 28.18 11.0792 27.412C11.7272 26.632 12.2312 25.996 12.2312 25.072C12.2312 23.812 11.3192 22.72 9.60317 22.72C8.17517 22.72 7.27517 23.896 7.27517 23.896C7.19117 23.992 7.21517 24.136 7.28717 24.208L7.69517 24.616C7.79117 24.712 7.92317 24.712 8.01917 24.616C8.34317 24.268 8.88317 23.812 9.54317 23.812C10.5992 23.812 11.0192 24.508 11.0192 25.12C11.0192 25.6 10.7072 26.2 10.1072 26.872C9.21917 27.928 7.97117 29.452 7.08317 30.46V30.772Z',
    fill: '#393939'
  }));
}

function BottleGray4() {
  return React__default.createElement("svg", {
    width: '16',
    height: '38',
    viewBox: '0 0 16 38',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React__default.createElement("path", {
    d: 'M14.7327 21.1004C14.4206 19.3364 13.1778 16.714 12.9123 16.12C12.6469 15.5256 10.9215 12.202 10.4909 10.2296C10.1113 8.488 9.89254 3.882 9.86841 3.3536C9.8668 3.3208 9.87753 3.2892 9.89951 3.2608L9.92203 3.2316C9.95795 3.1848 9.96332 3.128 9.93597 3.078C9.90755 3.0264 9.91399 2.968 9.95313 2.9204L10.1413 2.6912C10.1703 2.656 10.1815 2.614 10.173 2.5732L10.0974 2.2068C10.0909 2.176 10.0738 2.1468 10.047 2.1228L9.96922 2.0516C9.92793 2.0136 9.9097 1.9652 9.91881 1.9168C9.93919 1.8044 9.96546 1.584 9.90273 1.3968C9.82069 1.152 9.73865 1.134 9.51614 1.028C9.47914 1.0092 9.43517 1 9.39067 1H7.94832H6.60946C6.56496 1 6.52153 1.0092 6.484 1.0272C6.26148 1.1336 6.17944 1.1516 6.0974 1.396C6.03467 1.5832 6.06094 1.8036 6.08132 1.916C6.09043 1.9644 6.0722 2.0132 6.03092 2.0508L5.95317 2.122C5.9269 2.1464 5.9092 2.1752 5.90277 2.206L5.82716 2.5724C5.81859 2.6132 5.82985 2.6552 5.8588 2.6904L6.047 2.92C6.08614 2.9676 6.09258 3.026 6.06416 3.0776C6.03681 3.1276 6.04164 3.1844 6.0781 3.2312L6.10062 3.2604C6.1226 3.2888 6.13333 3.3208 6.13172 3.3532C6.10759 3.8816 5.88936 8.4876 5.50921 10.2292C5.07918 12.2016 3.35373 15.5256 3.08778 16.1196C2.82237 16.714 1.57949 19.3364 1.26743 21.1C0.942495 22.9344 0.973594 29.6856 1.05188 30.7112C1.10979 31.468 1.05563 34.7632 1.15322 35.6412C1.20094 36.0684 1.45455 36.3616 1.57252 36.4588C2.15535 36.938 7.93492 37 7.93492 37C7.93492 37 13.8448 36.938 14.4271 36.4592C14.545 36.3624 14.7987 36.0688 14.8464 35.6416C14.9445 34.7636 14.8898 31.4684 14.9477 30.7116C15.0265 29.686 15.0576 22.9348 14.7327 21.1004Z',
    fill: 'white',
    stroke: '#393939',
    strokeWidth: '0.75'
  }), React__default.createElement("path", {
    d: 'M4.86336 29.212H8.77536V30.772C8.77536 30.892 8.88336 31 9.00336 31H9.71136C9.83136 31 9.93936 30.892 9.93936 30.772L9.92736 29.188H10.8994C11.0314 29.188 11.1274 29.08 11.1274 28.96V28.456C11.1274 28.336 11.0314 28.24 10.8994 28.24H9.92736V22.936C9.92736 22.804 9.81936 22.708 9.69936 22.708H9.25536C9.20736 22.708 9.11136 22.744 9.07536 22.78L4.63536 28.264V28.984C4.63536 29.104 4.73136 29.212 4.86336 29.212ZM5.93136 28.216L8.82336 24.688V28.216H5.93136Z',
    fill: '#393939'
  }));
}

function BottleBack$1() {
  return React__default.createElement("svg", {
    width: '16',
    height: '38',
    viewBox: '0 0 16 38',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React__default.createElement("path", {
    d: 'M14.7327 21.1004C14.4206 19.3364 13.1778 16.714 12.9123 16.12C12.6469 15.5256 10.9215 12.202 10.4909 10.2296C10.1113 8.488 9.89254 3.882 9.86841 3.3536C9.8668 3.3208 9.87753 3.2892 9.89951 3.2608L9.92203 3.2316C9.95795 3.1848 9.96332 3.128 9.93597 3.078C9.90755 3.0264 9.91399 2.968 9.95313 2.9204L10.1413 2.6912C10.1703 2.656 10.1815 2.614 10.173 2.5732L10.0974 2.2068C10.0909 2.176 10.0738 2.1468 10.047 2.1228L9.96922 2.0516C9.92793 2.0136 9.9097 1.9652 9.91881 1.9168C9.93919 1.8044 9.96546 1.584 9.90273 1.3968C9.82069 1.152 9.73865 1.134 9.51614 1.028C9.47914 1.0092 9.43517 1 9.39067 1H7.94832H6.60946C6.56496 1 6.52153 1.0092 6.484 1.0272C6.26148 1.1336 6.17944 1.1516 6.0974 1.396C6.03467 1.5832 6.06094 1.8036 6.08132 1.916C6.09043 1.9644 6.0722 2.0132 6.03092 2.0508L5.95317 2.122C5.9269 2.1464 5.9092 2.1752 5.90277 2.206L5.82716 2.5724C5.81859 2.6132 5.82985 2.6552 5.8588 2.6904L6.047 2.92C6.08614 2.9676 6.09258 3.026 6.06416 3.0776C6.03681 3.1276 6.04164 3.1844 6.0781 3.2312L6.10062 3.2604C6.1226 3.2888 6.13333 3.3208 6.13172 3.3532C6.10759 3.8816 5.88936 8.4876 5.50921 10.2292C5.07918 12.2016 3.35373 15.5256 3.08778 16.1196C2.82237 16.714 1.57949 19.3364 1.26743 21.1C0.942495 22.9344 0.973594 29.6856 1.05188 30.7112C1.10979 31.468 1.05563 34.7632 1.15322 35.6412C1.20094 36.0684 1.45455 36.3616 1.57252 36.4588C2.15535 36.938 7.93492 37 7.93492 37C7.93492 37 13.8448 36.938 14.4271 36.4592C14.545 36.3624 14.7987 36.0688 14.8464 35.6416C14.9445 34.7636 14.8898 31.4684 14.9477 30.7116C15.0265 29.686 15.0576 22.9348 14.7327 21.1004Z',
    fill: 'white',
    stroke: '#393939',
    strokeWidth: '0.75'
  }), React__default.createElement("path", {
    d: 'M4.86336 29.212H8.77536V30.772C8.77536 30.892 8.88336 31 9.00336 31H9.71136C9.83136 31 9.93936 30.892 9.93936 30.772L9.92736 29.188H10.8994C11.0314 29.188 11.1274 29.08 11.1274 28.96V28.456C11.1274 28.336 11.0314 28.24 10.8994 28.24H9.92736V22.936C9.92736 22.804 9.81936 22.708 9.69936 22.708H9.25536C9.20736 22.708 9.11136 22.744 9.07536 22.78L4.63536 28.264V28.984C4.63536 29.104 4.73136 29.212 4.86336 29.212ZM5.93136 28.216L8.82336 24.688V28.216H5.93136Z',
    fill: '#393939'
  }));
}

function BottleGray24() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "38",
    fill: "none",
    viewBox: "0 0 16 38"
  }, React__default.createElement("path", {
    fill: "#fff",
    stroke: "#373634",
    strokeWidth: "0.75",
    d: "M14.733 21.1c-.312-1.764-1.555-4.386-1.82-4.98-.266-.594-1.992-3.918-2.422-5.89-.38-1.742-.598-6.348-.623-6.876A.139.139 0 019.9 3.26l.022-.03a.137.137 0 00.014-.153.137.137 0 01.017-.158l.188-.229a.14.14 0 00.032-.118l-.076-.366a.157.157 0 00-.05-.084l-.078-.071a.145.145 0 01-.05-.135c.02-.113.046-.333-.016-.52-.082-.245-.164-.263-.387-.369A.28.28 0 009.391 1H6.609a.292.292 0 00-.125.027c-.223.107-.305.125-.387.369-.062.187-.036.408-.016.52a.145.145 0 01-.05.135l-.078.071a.161.161 0 00-.05.084l-.076.366a.139.139 0 00.032.118l.188.23c.04.048.046.106.017.158a.136.136 0 00.014.153l.023.03a.14.14 0 01.03.092c-.023.529-.242 5.135-.622 6.876-.43 1.973-2.155 5.297-2.421 5.89-.266.595-1.509 3.217-1.82 4.981-.326 1.834-.294 8.586-.216 9.611.058.757.004 4.052.101 4.93.048.427.302.72.42.818.582.479 6.362.541 6.362.541s5.91-.062 6.492-.54c.118-.098.372-.391.42-.818.098-.878.043-4.174.1-4.93.08-1.026.11-7.777-.214-9.612z"
  }), React__default.createElement("path", {
    fill: "#373634",
    d: "M2.612 29.791c0 .11.088.209.21.209h4.256c.11 0 .21-.099.21-.209v-.528a.216.216 0 00-.21-.209H4.273a110.13 110.13 0 002.002-2.343c.594-.715 1.056-1.298 1.056-2.145 0-1.155-.836-2.156-2.409-2.156-1.309 0-2.134 1.078-2.134 1.078-.077.088-.055.22.011.286l.374.374a.2.2 0 00.297 0c.297-.319.792-.737 1.397-.737.968 0 1.353.638 1.353 1.199 0 .44-.286.99-.836 1.606-.814.968-1.958 2.365-2.772 3.289v.286zm5.036-1.43h3.586v1.43c0 .11.1.209.21.209h.648c.11 0 .21-.099.21-.209l-.012-1.452h.891a.209.209 0 00.21-.209v-.462c0-.11-.089-.198-.21-.198h-.89v-4.862a.209.209 0 00-.21-.209h-.407a.31.31 0 00-.165.066l-4.07 5.027v.66c0 .11.088.209.21.209zm.98-.913l2.65-3.234v3.234h-2.65z"
  }));
}

function BottleBlue24() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "36",
    fill: "none",
    viewBox: "0 0 14 36"
  }, React__default.createElement("path", {
    fill: "#46789E",
    d: "M13.733 20.1c-.312-1.764-1.555-4.386-1.82-4.98-.266-.594-1.992-3.918-2.422-5.89-.38-1.742-.598-6.348-.623-6.876A.139.139 0 018.9 2.26l.022-.03a.137.137 0 00.014-.153.137.137 0 01.017-.158l.188-.229a.139.139 0 00.032-.118l-.076-.366a.156.156 0 00-.05-.084l-.078-.071a.145.145 0 01-.05-.135c.02-.113.046-.333-.016-.52C8.82.152 8.739.134 8.516.028A.28.28 0 008.391 0H5.609a.292.292 0 00-.125.027c-.223.107-.305.125-.387.369-.062.187-.036.408-.016.52a.145.145 0 01-.05.135l-.078.071a.161.161 0 00-.05.084l-.076.366a.139.139 0 00.032.118l.188.23c.04.048.046.106.017.158a.136.136 0 00.014.153l.023.03a.14.14 0 01.03.092c-.023.529-.242 5.135-.622 6.876-.43 1.973-2.155 5.297-2.421 5.89-.266.595-1.509 3.217-1.82 4.981-.326 1.834-.294 8.586-.216 9.611.058.757.004 4.052.101 4.93.048.427.302.72.42.818.582.479 6.362.541 6.362.541s5.91-.062 6.492-.54c.118-.098.372-.391.42-.818.098-.878.043-4.174.1-4.93.08-1.026.11-7.777-.214-9.612z"
  }), React__default.createElement("path", {
    fill: "#fff",
    d: "M1.612 28.791c0 .11.088.209.21.209h4.256c.11 0 .21-.099.21-.209v-.528a.216.216 0 00-.21-.209H3.273a110.13 110.13 0 002.002-2.343c.594-.715 1.056-1.298 1.056-2.145 0-1.155-.836-2.156-2.409-2.156-1.309 0-2.134 1.078-2.134 1.078-.077.088-.055.22.011.286l.374.374a.2.2 0 00.297 0c.297-.319.792-.737 1.397-.737.968 0 1.353.638 1.353 1.199 0 .44-.286.99-.836 1.606-.814.968-1.958 2.365-2.772 3.289v.286zm5.036-1.43h3.586v1.43c0 .11.1.209.21.209h.648c.11 0 .21-.099.21-.209l-.012-1.452h.891a.209.209 0 00.21-.209v-.462c0-.11-.089-.198-.21-.198h-.89v-4.862a.209.209 0 00-.21-.209h-.407a.31.31 0 00-.165.066l-4.07 5.027v.66c0 .11.088.209.21.209zm.98-.913l2.65-3.234v3.234h-2.65z"
  }));
}

function BottleGray36() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "38",
    fill: "none",
    viewBox: "0 0 16 38"
  }, React__default.createElement("path", {
    fill: "#fff",
    stroke: "#373634",
    strokeWidth: "0.75",
    d: "M14.733 21.1c-.312-1.764-1.555-4.386-1.82-4.98-.266-.594-1.992-3.918-2.422-5.89-.38-1.742-.598-6.348-.623-6.876A.139.139 0 019.9 3.26l.022-.03a.137.137 0 00.014-.153.137.137 0 01.017-.158l.188-.229a.14.14 0 00.032-.118l-.076-.366a.157.157 0 00-.05-.084l-.078-.071a.145.145 0 01-.05-.135c.02-.113.046-.333-.016-.52-.082-.245-.164-.263-.387-.369A.28.28 0 009.391 1H6.609a.292.292 0 00-.125.027c-.223.107-.305.125-.387.369-.062.187-.036.408-.016.52a.145.145 0 01-.05.135l-.078.071a.161.161 0 00-.05.084l-.076.366a.139.139 0 00.032.118l.188.23c.04.048.046.106.017.158a.136.136 0 00.014.153l.023.03a.14.14 0 01.03.092c-.023.529-.242 5.135-.622 6.876-.43 1.973-2.155 5.297-2.421 5.89-.266.595-1.509 3.217-1.82 4.981-.326 1.834-.294 8.586-.216 9.611.058.757.004 4.052.101 4.93.048.427.302.72.42.818.582.479 6.362.541 6.362.541s5.91-.062 6.492-.54c.118-.098.372-.391.42-.818.098-.878.043-4.174.1-4.93.08-1.026.11-7.777-.214-9.612z"
  }), React__default.createElement("path", {
    fill: "#373634",
    d: "M2.85 29.131c.242.286.891.979 2.255.979 1.518 0 2.486-.902 2.486-2.101 0-.946-.814-1.606-1.33-1.826v-.033c.494-.231 1.132-.88 1.132-1.727 0-1.232-1.023-2.013-2.299-2.013-1.199 0-2.035.968-2.035.968-.077.077-.088.209 0 .286l.407.363c.1.088.22.066.286-.022.22-.242.616-.616 1.276-.616.65 0 1.254.462 1.254 1.199 0 .649-.517 1.177-1.55 1.177h-.617c-.154 0-.22.066-.22.231v.473c0 .154.088.231.21.231h.615c1.177 0 1.738.627 1.738 1.287 0 .737-.66 1.188-1.375 1.188-.814 0-1.43-.594-1.496-.682-.088-.099-.187-.11-.297-.022l-.429.396c-.077.066-.077.187-.01.264zM8.19 27.03c0 1.694.836 3.08 2.595 3.08 1.332 0 2.454-1.133 2.454-2.519 0-1.518-1.133-2.387-2.3-2.387-.737 0-1.374.352-1.462.407.363-1.353 2.111-2.266 2.617-2.431.21-.066.254-.187.198-.319l-.187-.451c-.043-.121-.143-.176-.274-.132-1.012.385-3.641 1.683-3.641 4.752zm2.585 2.09c-1.2 0-1.606-1.254-1.518-2.178.066-.198.638-.836 1.506-.836.814 0 1.463.671 1.463 1.496s-.637 1.518-1.451 1.518z"
  }));
}

function BottleBlue36() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "36",
    fill: "none",
    viewBox: "0 0 14 36"
  }, React__default.createElement("path", {
    fill: "#46789E",
    d: "M13.733 20.1c-.312-1.764-1.555-4.386-1.82-4.98-.266-.594-1.992-3.918-2.422-5.89-.38-1.742-.598-6.348-.623-6.876A.139.139 0 018.9 2.26l.022-.03a.137.137 0 00.014-.153.137.137 0 01.017-.158l.188-.229a.139.139 0 00.032-.118l-.076-.366a.156.156 0 00-.05-.084l-.078-.071a.145.145 0 01-.05-.135c.02-.113.046-.333-.016-.52C8.82.152 8.739.134 8.516.028A.28.28 0 008.391 0H5.609a.292.292 0 00-.125.027c-.223.107-.305.125-.387.369-.062.187-.036.408-.016.52a.145.145 0 01-.05.135l-.078.071a.161.161 0 00-.05.084l-.076.366a.139.139 0 00.032.118l.188.23c.04.048.046.106.017.158a.136.136 0 00.014.153l.023.03a.14.14 0 01.03.092c-.023.529-.242 5.135-.622 6.876-.43 1.973-2.155 5.297-2.421 5.89-.266.595-1.509 3.217-1.82 4.981-.326 1.834-.294 8.586-.216 9.611.058.757.004 4.052.101 4.93.048.427.302.72.42.818.582.479 6.362.541 6.362.541s5.91-.062 6.492-.54c.118-.098.372-.391.42-.818.098-.878.043-4.174.1-4.93.08-1.026.11-7.777-.214-9.612z"
  }), React__default.createElement("path", {
    fill: "#fff",
    d: "M1.85 28.131c.242.286.891.979 2.255.979 1.518 0 2.486-.902 2.486-2.101 0-.946-.814-1.606-1.33-1.826v-.033c.494-.231 1.132-.88 1.132-1.727 0-1.232-1.023-2.013-2.299-2.013-1.199 0-2.035.968-2.035.968-.077.077-.088.209 0 .286l.407.363c.1.088.22.066.286-.022.22-.242.616-.616 1.276-.616.65 0 1.254.462 1.254 1.199 0 .649-.517 1.177-1.55 1.177h-.617c-.154 0-.22.066-.22.231v.473c0 .154.088.231.21.231h.615c1.177 0 1.738.627 1.738 1.287 0 .737-.66 1.188-1.375 1.188-.814 0-1.43-.594-1.496-.682-.088-.099-.187-.11-.297-.022l-.429.396c-.077.066-.077.187-.01.264zM7.19 26.03c0 1.694.836 3.08 2.596 3.08 1.33 0 2.453-1.133 2.453-2.519 0-1.518-1.133-2.387-2.3-2.387-.736 0-1.374.352-1.462.407.363-1.353 2.111-2.266 2.617-2.431.21-.066.254-.187.198-.319l-.187-.451c-.043-.121-.143-.176-.274-.132-1.012.385-3.641 1.683-3.641 4.752zm2.585 2.09c-1.2 0-1.606-1.254-1.518-2.178.066-.198.638-.836 1.507-.836.813 0 1.463.671 1.463 1.496s-.639 1.518-1.452 1.518z"
  }));
}

function BottleGray48() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "38",
    fill: "none",
    viewBox: "0 0 16 38"
  }, React__default.createElement("path", {
    fill: "#fff",
    stroke: "#373634",
    strokeWidth: "0.75",
    d: "M14.733 21.1c-.312-1.764-1.555-4.386-1.82-4.98-.266-.594-1.992-3.918-2.422-5.89-.38-1.742-.598-6.348-.623-6.876A.139.139 0 019.9 3.26l.022-.03a.137.137 0 00.014-.153.137.137 0 01.017-.158l.188-.229a.14.14 0 00.032-.118l-.076-.366a.157.157 0 00-.05-.084l-.078-.071a.145.145 0 01-.05-.135c.02-.113.046-.333-.016-.52-.082-.245-.164-.263-.387-.369A.28.28 0 009.391 1H6.609a.292.292 0 00-.125.027c-.223.107-.305.125-.387.369-.062.187-.036.408-.016.52a.145.145 0 01-.05.135l-.078.071a.161.161 0 00-.05.084l-.076.366a.139.139 0 00.032.118l.188.23c.04.048.046.106.017.158a.136.136 0 00.014.153l.023.03a.14.14 0 01.03.092c-.023.529-.242 5.135-.622 6.876-.43 1.973-2.155 5.297-2.421 5.89-.266.595-1.509 3.217-1.82 4.981-.326 1.834-.294 8.586-.216 9.611.058.757.004 4.052.101 4.93.048.427.302.72.42.818.582.479 6.362.541 6.362.541s5.91-.062 6.492-.54c.118-.098.372-.391.42-.818.098-.878.043-4.174.1-4.93.08-1.026.11-7.777-.214-9.612z"
  }), React__default.createElement("path", {
    fill: "#373634",
    d: "M2.252 28.361h3.586v1.43c0 .11.1.209.21.209h.648c.11 0 .21-.099.21-.209l-.012-1.452h.891a.209.209 0 00.21-.209v-.462c0-.11-.089-.198-.21-.198h-.89v-4.862a.209.209 0 00-.21-.209h-.407a.31.31 0 00-.165.066l-4.07 5.027v.66c0 .11.088.209.21.209zm.98-.913l2.65-3.234v3.234h-2.65zm5.21.55c0 1.199.98 2.112 2.52 2.112 1.595 0 2.563-.913 2.563-2.112 0-.946-.825-1.606-1.331-1.837v-.044c.473-.242 1.133-.847 1.133-1.694 0-1.21-1.001-2.013-2.354-2.013-1.32 0-2.332.803-2.332 2.013 0 .858.66 1.463 1.133 1.705v.033c-.407.187-1.331.88-1.331 1.837zm2.542-2.354c-.858-.132-1.232-.583-1.232-1.177 0-.671.539-1.155 1.199-1.155.726 0 1.265.484 1.265 1.155 0 .583-.385 1.056-1.232 1.177zM9.587 28.02c0-.583.506-1.188 1.397-1.32.89.132 1.397.737 1.397 1.32 0 .737-.627 1.199-1.408 1.199-.726 0-1.386-.473-1.386-1.199z"
  }));
}

function BottleBlue48() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "36",
    fill: "none",
    viewBox: "0 0 14 36"
  }, React__default.createElement("path", {
    fill: "#46789E",
    d: "M13.733 20.1c-.312-1.764-1.555-4.386-1.82-4.98-.266-.594-1.992-3.918-2.422-5.89-.38-1.742-.598-6.348-.623-6.876A.139.139 0 018.9 2.26l.022-.03a.137.137 0 00.014-.153.137.137 0 01.017-.158l.188-.229a.139.139 0 00.032-.118l-.076-.366a.156.156 0 00-.05-.084l-.078-.071a.145.145 0 01-.05-.135c.02-.113.046-.333-.016-.52C8.82.152 8.739.134 8.516.028A.28.28 0 008.391 0H5.609a.292.292 0 00-.125.027c-.223.107-.305.125-.387.369-.062.187-.036.408-.016.52a.145.145 0 01-.05.135l-.078.071a.161.161 0 00-.05.084l-.076.366a.139.139 0 00.032.118l.188.23c.04.048.046.106.017.158a.136.136 0 00.014.153l.023.03a.14.14 0 01.03.092c-.023.529-.242 5.135-.622 6.876-.43 1.973-2.155 5.297-2.421 5.89-.266.595-1.509 3.217-1.82 4.981-.326 1.834-.294 8.586-.216 9.611.058.757.004 4.052.101 4.93.048.427.302.72.42.818.582.479 6.362.541 6.362.541s5.91-.062 6.492-.54c.118-.098.372-.391.42-.818.098-.878.043-4.174.1-4.93.08-1.026.11-7.777-.214-9.612z"
  }), React__default.createElement("path", {
    fill: "#fff",
    d: "M1.252 27.361h3.586v1.43c0 .11.1.209.21.209h.648c.11 0 .21-.099.21-.209l-.012-1.452h.891a.209.209 0 00.21-.209v-.462c0-.11-.089-.198-.21-.198h-.89v-4.862a.209.209 0 00-.21-.209h-.407a.31.31 0 00-.165.066l-4.07 5.027v.66c0 .11.088.209.21.209zm.98-.913l2.65-3.234v3.234h-2.65zm5.21.55c0 1.199.98 2.112 2.52 2.112 1.595 0 2.563-.913 2.563-2.112 0-.946-.825-1.606-1.331-1.837v-.044c.473-.242 1.133-.847 1.133-1.694 0-1.21-1.001-2.013-2.354-2.013-1.32 0-2.332.803-2.332 2.013 0 .858.66 1.463 1.133 1.705v.033c-.407.187-1.331.88-1.331 1.837zm2.542-2.354c-.858-.132-1.232-.583-1.232-1.177 0-.671.539-1.155 1.199-1.155.726 0 1.265.484 1.265 1.155 0 .583-.385 1.056-1.232 1.177zM8.587 27.02c0-.583.506-1.188 1.397-1.32.89.132 1.397.737 1.397 1.32 0 .737-.627 1.199-1.408 1.199-.726 0-1.386-.473-1.386-1.199z"
  }));
}

var LaunchDates = {
  octFirst2020: /*#__PURE__*/new Date('2020-10-01T14:07:00.000Z')
};

var cssConstants$a = styles.cssConstants;
var fourPackEnabled = /*#__PURE__*/new Date() >= LaunchDates.octFirst2020;
var emptyArray = /*#__PURE__*/new Array(12);
function getBottles(cartQty) {
  var qualifiedCartTotalModulo = cartQty % 12;
  var hasQualifiedCartItems = cartQty > 0;
  emptyArray.fill(BottleGray);
  var hasReachedMaxDiscountThreshold = cartQty > 12;
  var has12orMore = cartQty >= 12;
  var has24orMore = cartQty >= 24;
  var has36orMore = cartQty >= 36;
  var has24 = cartQty === 24;
  var has36 = cartQty === 36;
  var has48 = cartQty === 48;
  return emptyArray.map(function (_img, index) {
    var bottleIndex = index + 1;
    var isFirst6Bottles = bottleIndex <= 6;
    var isLast6Bottles = bottleIndex > 6;
    var isDiscount20 = qualifiedCartTotalModulo === 0 && cartQty > 0;
    var isDiscount10 = qualifiedCartTotalModulo >= 6;
    var isDiscount5 = qualifiedCartTotalModulo >= 4 && fourPackEnabled;
    var isBottleSelected = bottleIndex <= qualifiedCartTotalModulo;
    var isBlackBottle = isLast6Bottles && isBottleSelected && bottleIndex < 12 || isFirst6Bottles && qualifiedCartTotalModulo < 6 && isBottleSelected && !isDiscount5 || bottleIndex === 5 && isDiscount5 && isBottleSelected && !isDiscount20 && !isDiscount10 && fourPackEnabled;
    var isBlueBottle = isDiscount20 || isDiscount10 && isBottleSelected || isDiscount5 && isBottleSelected && fourPackEnabled;
    var maxDiscountBlueBottle = hasReachedMaxDiscountThreshold && isBottleSelected;
    var isMidBottle = bottleIndex === 6 && !isDiscount10;
    var isLastBottle = bottleIndex === 12 && !isDiscount20;
    var isFourthBottle = bottleIndex === 4 && fourPackEnabled;
    var isMidBottleSelected = bottleIndex === 6 && (isDiscount10 || isDiscount20);
    var isLastBottleSelected = bottleIndex === 12 && isDiscount20;

    switch (true) {
      case has24 && hasReachedMaxDiscountThreshold && isLastBottleSelected:
        return {
          img: BottleBlue24,
          imagePath: 'imgUrl24Blue'
        };

      case has36 && hasReachedMaxDiscountThreshold && isLastBottleSelected:
        return {
          img: BottleBlue36,
          imagePath: 'imgUrl36Blue'
        };

      case has48 && hasReachedMaxDiscountThreshold && isLastBottleSelected:
        return {
          img: BottleBlue48,
          imagePath: 'imgUrl48Blue'
        };

      case maxDiscountBlueBottle || !isLastBottle && hasReachedMaxDiscountThreshold && cartQty % 12 === 0:
        return {
          img: BottleBlue,
          imagePath: 'imgUrlBlue'
        };

      case isMidBottleSelected:
        return {
          img: BottleBlue6,
          imagePath: 'imgUrlSixthBlue'
        };

      case isLastBottleSelected:
        return {
          img: BottleBlue12,
          imagePath: 'imgUrlTwelfthBlue'
        };

      case hasReachedMaxDiscountThreshold && has36orMore && isLastBottle:
        return {
          img: BottleGray48,
          imagePath: 'imgUrl48Grey'
        };

      case hasReachedMaxDiscountThreshold && has24orMore && isLastBottle:
        return {
          img: BottleGray36,
          imagePath: 'imgUrl36Grey'
        };

      case hasReachedMaxDiscountThreshold && has12orMore && isLastBottle:
        return {
          img: BottleGray24,
          imagePath: 'imgUrl24Grey'
        };

      case hasReachedMaxDiscountThreshold && (isFourthBottle || isMidBottle):
        return {
          img: BottleGray,
          imagePath: 'imgUrlGrey'
        };

      case !hasQualifiedCartItems && isFourthBottle:
        return {
          img: BottleBack$1,
          imagePath: 'imgUrlFourthBlack'
        };

      case !hasQualifiedCartItems && isMidBottle:
        return {
          img: BottleBlack6,
          imagePath: 'imgUrlSixthBlack'
        };

      case !hasQualifiedCartItems && isLastBottle:
        return {
          img: BottleBlack12,
          imagePath: 'imgUrlTwelfthBlack'
        };

      case isFourthBottle && fourPackEnabled:
        if (isDiscount5 || isDiscount10 || isDiscount20) {
          return {
            img: BottleBlue4,
            imagePath: 'imgUrlFourthBlue'
          };
        }

        return {
          img: BottleGray4,
          imagePath: 'imgUrlFourthGrey'
        };

      case isMidBottle:
        return {
          img: BottleGray6,
          imagePath: 'imgUrlSixthGrey'
        };

      case isLastBottle:
        return {
          img: BottleGray12,
          imagePath: 'imgUrlTwelfthGrey'
        };

      case isBlackBottle:
        return {
          img: BottleBack,
          imagePath: 'imgUrlBlack'
        };

      case isBlueBottle:
        return {
          img: BottleBlue,
          imagePath: 'imgUrlBlue'
        };

      case hasQualifiedCartItems:
      default:
        return {
          img: BottleGray,
          imagePath: 'imgUrlGrey'
        };
    }
  });
}
function getPercentageColor(imgPath) {
  switch (imgPath) {
    case 'imgUrlSixthBlack':
      return cssConstants$a.black2;

    case 'imgUrlTwelfthBlack':
      return cssConstants$a.black2;

    case 'imgUrlSixthGrey':
      return cssConstants$a.black2;

    case 'imgUrlTwelfthGrey':
      return cssConstants$a.black2;

    case 'imgUrlFourthBlue':
      return cssConstants$a.blue0;

    case 'imgUrlSixthBlue':
      return cssConstants$a.blue0;

    case 'imgUrlTwelfthBlue':
      return cssConstants$a.blue0;

    case 'imgUrlFourthBlack':
      return cssConstants$a.black2;

    case 'imgUrlFourthGrey':
      return cssConstants$a.black2;

    default:
      return 'transparent';
  }
}

var _templateObject$e, _templateObject2$a;
var cssConstants$b = styles.cssConstants;
var Percentage = /*#__PURE__*/styled.span(_templateObject$e || (_templateObject$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: block;\n  margin-top: 8px;\n"])));
var ArrowContainer = /*#__PURE__*/styled.span(_templateObject2$a || (_templateObject2$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: ", ";\n  display: ", ";\n  position: absolute;\n  top: 30px;\n  font-size: 11px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.64;\n  letter-spacing: normal;\n  text-align: center;\n  width: 27px;\n  font-family: ", ";\n"])), function (p) {
  return p === null || p === void 0 ? void 0 : p.color;
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.color) === "transparent" ? "none" : "block";
}, cssConstants$b.tertiaryFont);
var Case4CauseFivePercent = function Case4CauseFivePercent(_ref) {
  var imgPath = _ref.imgPath,
      bottleDiscount = _ref.bottleDiscount;

  if (imgPath === "imgUrlFourthBlue" || imgPath === "imgUrlFourthGrey" || imgPath === "imgUrlFourthBlack") {
    var percentage = bottleDiscount + "%";
    return createElement(ArrowContainer, {
      color: getPercentageColor(imgPath)
    }, createElement(Percentage, null, percentage));
  }

  return null;
};
var Case4CauseTenPercent = function Case4CauseTenPercent(_ref2) {
  var imgPath = _ref2.imgPath,
      bottleDiscount = _ref2.bottleDiscount;

  if (imgPath === "imgUrlSixthBlue" || imgPath === "imgUrlSixthGrey" || imgPath === "imgUrlSixthBlack") {
    var percentage = bottleDiscount + "%";
    return createElement(ArrowContainer, {
      color: getPercentageColor(imgPath)
    }, createElement(Percentage, null, percentage));
  }

  return null;
};
var Case4CauseTwentyPercent = function Case4CauseTwentyPercent(_ref3) {
  var imgPath = _ref3.imgPath,
      bottleDiscount = _ref3.bottleDiscount;

  if (imgPath === "imgUrlTwelfthBlue" || imgPath === "imgUrlTwelfthGrey" || imgPath === "imgUrlTwelfthBlack") {
    var percentage = bottleDiscount + "%";
    return createElement(ArrowContainer, {
      color: getPercentageColor(imgPath)
    }, createElement(Percentage, null, percentage));
  }

  return null;
};

var _templateObject$f, _templateObject2$b;
var Container$1 = /*#__PURE__*/styled.div(_templateObject$f || (_templateObject$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding-bottom: 16px;\n"])));
var BottleContainer = /*#__PURE__*/styled.span(_templateObject2$b || (_templateObject2$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 0 2px;\n  @media all and (min-width: 768px) {\n    padding: 0 4px;\n  }\n"])));
function Case4CauseBottlesBase(props) {
  var discountQualifiedCartTotal = props.discountQualifiedCartTotal;
  var cartQty = discountQualifiedCartTotal || 0;
  var bottles = getBottles(cartQty);
  var c4cCartTotal = cartQty >= 0 ? cartQty : 0;
  var qtyInCart = c4cCartTotal % 12;
  var isDiscount20 = c4cCartTotal >= 12 && qtyInCart === 0;
  var isDiscount10 = c4cCartTotal < 12 && c4cCartTotal >= 6 && qtyInCart === 0;
  var isDiscount5 = c4cCartTotal < 6 && c4cCartTotal >= 4 || c4cCartTotal < 18 && c4cCartTotal >= 16;
  var hasReachedMaxDiscountThreshold = c4cCartTotal > 12;
  var bottlesArray = bottles.map(function (Img, index) {
    return createElement("span", {
      key: "" + index + index + isDiscount20
    }, createElement(BottleContainer, null, createElement(Img.img, null)), !hasReachedMaxDiscountThreshold && createElement(Case4CauseFivePercent, {
      imgPath: Img.imagePath,
      isDiscount20: isDiscount20,
      isDiscount10: isDiscount10,
      bottleDiscount: props.bottleDiscount4,
      index: index
    }), !hasReachedMaxDiscountThreshold && createElement(Case4CauseTenPercent, {
      imgPath: Img.imagePath,
      isDiscount20: isDiscount20,
      isDiscount5: isDiscount5,
      bottleDiscount: props.bottleDiscount6
    }), !hasReachedMaxDiscountThreshold && createElement(Case4CauseTwentyPercent, {
      imgPath: Img.imagePath,
      isDiscount20: isDiscount20,
      bottleDiscount: props.bottleDiscount12
    }));
  });
  return createElement(Container$1, null, bottlesArray);
}
var Case4CauseBottles = /*#__PURE__*/memo(Case4CauseBottlesBase);

var _templateObject$g;
var cssConstants$c = styles.cssConstants;
var Container$2 = /*#__PURE__*/styled.div(_templateObject$g || (_templateObject$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 19px;\n  font-family: ", ";\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  height: 82px;\n"])), cssConstants$c.tertiaryFont);
function PCUpsellHeader() {
  var _useCartContextValue = useCartContextValue(),
      _useCartContextValue$ = _useCartContextValue[0],
      viaQualifiedCartTotal = _useCartContextValue$.viaQualifiedCartTotal,
      cart = _useCartContextValue$.cart;

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Container$2, null, React__default.createElement(PCSavingsText, {
    discountQualifiedCartTotal: viaQualifiedCartTotal,
    bottleDiscount4: cart === null || cart === void 0 ? void 0 : cart.bottleDiscount4,
    bottleDiscount6: cart === null || cart === void 0 ? void 0 : cart.bottleDiscount6,
    bottleDiscount12: cart === null || cart === void 0 ? void 0 : cart.bottleDiscount12,
    promoCodeSavings: cart === null || cart === void 0 ? void 0 : cart.promoCodeSavings
  }), React__default.createElement(Case4CauseBottles, {
    discountQualifiedCartTotal: viaQualifiedCartTotal,
    bottleDiscount4: cart === null || cart === void 0 ? void 0 : cart.bottleDiscount4,
    bottleDiscount6: cart === null || cart === void 0 ? void 0 : cart.bottleDiscount6,
    bottleDiscount12: cart === null || cart === void 0 ? void 0 : cart.bottleDiscount12
  })));
}

var _templateObject$h, _templateObject2$c, _templateObject3$9, _templateObject4$8, _templateObject5$5;
var cssConstants$d = styles.cssConstants;
var DiscountedCartItemsContainer = /*#__PURE__*/styled.div(_templateObject$h || (_templateObject$h = /*#__PURE__*/_taggedTemplateLiteralLoose([""])));
var PCUpsellHeaderContainer = /*#__PURE__*/styled.div(_templateObject2$c || (_templateObject2$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin-bottom: 16px;\n"])));
var BorderBottom = /*#__PURE__*/styled.div(_templateObject3$9 || (_templateObject3$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  height: 1px;\n  background-color: ", ";\n  width: 100%;\n  margin-top: 8px;\n  margin-bottom: 16px;\n"])), cssConstants$d.neutral5);
var BorderTop = /*#__PURE__*/styled.div(_templateObject4$8 || (_templateObject4$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  height: 1px;\n  background-color: ", ";\n  width: 100%;\n  margin-top: 8px;\n  margin-bottom: 16px;\n"])), cssConstants$d.neutral13);
var isWineClubProduct = function isWineClubProduct(product) {
  return !!((product === null || product === void 0 ? void 0 : product.productURLslug) === 'maris-picks' || (product === null || product === void 0 ? void 0 : product.productURLslug) === 'wine-club' || (product === null || product === void 0 ? void 0 : product.productURLslug) === 'wine-club-4-pack' || (product === null || product === void 0 ? void 0 : product.productURLslug) === 'wine-club-6-pack' || (product === null || product === void 0 ? void 0 : product.productURLslug) === 'wine-club-12-pack');
};
var NoDiscountedCartItemsContainer = /*#__PURE__*/styled.div(_templateObject5$5 || (_templateObject5$5 = /*#__PURE__*/_taggedTemplateLiteralLoose([""])));
function CartItemsWrapper() {
  var _user$cartV2$entries, _user$cartV2$entries$;

  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      user = _useCartNetworkLayerV.user,
      seasonalWineClubDateGate = _useCartNetworkLayerV.seasonalWineClubDateGate;

  var _useCartContextValue = useCartContextValue(),
      _useCartContextValue$ = _useCartContextValue[0],
      cart = _useCartContextValue$.cart,
      autoShipAtTop = _useCartContextValue$.autoShipAtTop;

  var hasItemsInCart = !!(user !== null && user !== void 0 && (_user$cartV2$entries = user.cartV2.entries) !== null && _user$cartV2$entries !== void 0 && (_user$cartV2$entries$ = _user$cartV2$entries.edges) !== null && _user$cartV2$entries$ !== void 0 && _user$cartV2$entries$.length);

  var _buildCart = buildCart(user === null || user === void 0 ? void 0 : user.cartV2),
      discountQualifyingItems = _buildCart.discountQualifyingItems,
      nonQualifyingItems = _buildCart.nonQualifyingItems;

  if (hasItemsInCart) {
    var _cart$promoCodes;

    var discountQualifyingItemsNoWc = [];
    var wineClubProducts = discountQualifyingItems === null || discountQualifyingItems === void 0 ? void 0 : discountQualifyingItems.filter(function (item) {
      if (isWineClubProduct(item.node)) {
        return true;
      }

      discountQualifyingItemsNoWc.push(item);
      return false;
    });
    var hasWineClubProducts = !!(wineClubProducts !== null && wineClubProducts !== void 0 && wineClubProducts.length);
    var isEligibleForGenericDiscount = !(cart !== null && cart !== void 0 && (_cart$promoCodes = cart.promoCodes) !== null && _cart$promoCodes !== void 0 && _cart$promoCodes.length);
    var showDiscountedCart = isEligibleForGenericDiscount && !!(discountQualifyingItems !== null && discountQualifyingItems !== void 0 && discountQualifyingItems.length);
    var showNonDiscountedCart = !!(nonQualifyingItems !== null && nonQualifyingItems !== void 0 && nonQualifyingItems.length);
    var showBottleUpsellATop = !!(isEligibleForGenericDiscount && (!autoShipAtTop || !(cart !== null && cart !== void 0 && cart.canSubscribeForAutoShip)));
    var showAutoShipAtTop = !!(cart !== null && cart !== void 0 && cart.canSubscribeForAutoShip && autoShipAtTop);
    return createElement(Fragment, null, showBottleUpsellATop && createElement(PCUpsellHeaderContainer, null, createElement(PCUpsellHeader, null), createElement(BorderBottom, null)), showDiscountedCart && createElement(DiscountedCartItemsContainer, null, showAutoShipAtTop && !hasWineClubProducts && createElement(AutoShipUpsell, null), createElement(CartItems, {
      showDiscountedCart: showDiscountedCart,
      items: seasonalWineClubDateGate ? discountQualifyingItemsNoWc : discountQualifyingItems,
      keyString: "discountedCartItem"
    }), seasonalWineClubDateGate && wineClubProducts && createElement(Fragment, null, createElement(BorderTop, null), createElement(CartItems, {
      showDiscountedCart: showDiscountedCart,
      items: wineClubProducts,
      keyString: "discountedWCCartItem"
    })), !showAutoShipAtTop && !hasWineClubProducts && createElement(AutoShipUpsell, null), !showBottleUpsellATop && createElement(PCUpsellHeaderContainer, null, createElement(PCUpsellHeader, null))), showNonDiscountedCart && createElement(NoDiscountedCartItemsContainer, null, createElement(CartItems, {
      showDiscountedCart: showDiscountedCart,
      items: nonQualifyingItems,
      keyString: "nonDiscountedCartItem"
    })));
  }

  return createElement(EmptyCart, null);
}

var _templateObject$i, _templateObject2$d, _templateObject3$a, _templateObject4$9, _templateObject5$6;
var cssConstants$e = styles.cssConstants;
var Dialog$3 = /*#__PURE__*/styled(MuiDialog)(_templateObject$i || (_templateObject$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    z-index: 10002 !important;\n    font-family: ", ";\n  }\n"])), cssConstants$e.tertiaryFont);
var DialogContent$1 = /*#__PURE__*/styled(MuiDialogContent)(_templateObject2$d || (_templateObject2$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0;\n  && {\n    font-family: ", ";\n    padding: 24px;\n    font-size: 24px;\n    font-weight: bold;\n    line-height: 29px;\n    text-align: center;\n    @media only screen and (min-width: 768px) {\n      padding: 48px;\n    }\n  }\n"])), cssConstants$e.tertiaryFont);
var Button$1 = /*#__PURE__*/styled(MuiButton)(_templateObject3$a || (_templateObject3$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    font-family: ", ";\n    margin: 24px;\n    width: 240px;\n  }\n"])), cssConstants$e.tertiaryFont);
var CloseButtonContainer$2 = /*#__PURE__*/styled.div(_templateObject4$9 || (_templateObject4$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 16px 0 16px;\n"])));
var IconButton$3 = /*#__PURE__*/styled(MuiIconButton)(_templateObject5$6 || (_templateObject5$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &.MuiIconButton-root {\n    padding: 3px !important;\n    border-radius: 50% !important;\n  }\n  .MuiSvgIcon-root {\n    width: 1.2em;\n    height: 1.2em;\n    color: black;\n  }\n"])));
function RemovePCDialog(_ref) {
  var setIsNotEditing = _ref.setIsNotEditing,
      isDialogOpen = _ref.isDialogOpen,
      setDialogClosed = _ref.setDialogClosed;

  var _useCartContextValue = useCartContextValue(),
      dispatch = _useCartContextValue[1];

  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      handlePromoCodeDelete = _useCartNetworkLayerV.handlePromoCodeDelete;

  var handleUpdateEnrollingState = function handleUpdateEnrollingState() {
    dispatch({
      type: TypeKeys.UPDATE_ENROLLING_AS_PC,
      enrollingAsPc: false
    });
  };

  var deletePromoCode = function deletePromoCode() {
    setDialogClosed();
    return handlePromoCodeDelete({
      code: 'GRAPEFULCLUB'
    }, setIsNotEditing, handleUpdateEnrollingState);
  };

  return createElement("div", null, createElement(Dialog$3, {
    open: isDialogOpen,
    onClose: setDialogClosed,
    "aria-labelledby": 'removePc-dialog'
  }, createElement(CloseButtonContainer$2, null, createElement(IconButton$3, {
    "aria-label": 'close',
    onClick: setDialogClosed
  }, createElement(CloseIcon$1, null))), createElement(DialogContent$1, null, createElement("div", null, "Are you sure you want to remove your Preferred Customer discount?"), createElement(Button$1 // @ts-ignore
  , {
    // @ts-ignore
    type: 'PRIMARY',
    onClick: deletePromoCode
  }, "Remove"))));
}

function useToggle(initial) {
  if (initial === void 0) {
    initial = false;
  }

  var _useState = useState(initial),
      value = _useState[0],
      setToggle = _useState[1];

  return {
    value: value,
    set: setToggle,
    setTrue: function setTrue() {
      return setToggle(true);
    },
    setFalse: function setFalse() {
      return setToggle(false);
    },
    reset: function reset() {
      return setToggle(initial);
    },
    toggle: function toggle() {
      return setToggle(function (prev) {
        return !prev;
      });
    }
  };
}

var _templateObject$j, _templateObject2$e, _templateObject3$b, _templateObject4$a, _templateObject5$7, _templateObject6$4, _templateObject7$3;
var cssConstants$f = styles.cssConstants;
var RemoveIcon = /*#__PURE__*/styled(CancelIcon)(_templateObject$j || (_templateObject$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    padding: 0 8px;\n    :hover {\n      cursor: pointer;\n    }\n  }\n"])));
var CheckCircleIcon = /*#__PURE__*/styled(CheckCircleIcon$1)(_templateObject2$e || (_templateObject2$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    fill: ", ";\n  }\n"])), cssConstants$f.successColor);
var FixedPromoContainer = /*#__PURE__*/styled.div(_templateObject3$b || (_templateObject3$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 19px;\n"])));
var SavingsText = /*#__PURE__*/styled.div(_templateObject4$a || (_templateObject4$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 0 24px;\n  font-weight: bold;\n  color: ", ";\n  white-space: nowrap;\n"])), cssConstants$f.googleColor);
var InputWrapper = /*#__PURE__*/styled.div(_templateObject5$7 || (_templateObject5$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 0 16px;\n  background-color: #f0f8fe;\n  width: 100%;\n  border-bottom: 1px solid ", ";\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n  height: 48px;\n"])), cssConstants$f.primaryColor);
var FixedPromoCodeContainer = /*#__PURE__*/styled.div(_templateObject6$4 || (_templateObject6$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"])));
var FixedPromoCodeText = /*#__PURE__*/styled.div(_templateObject7$3 || (_templateObject7$3 = /*#__PURE__*/_taggedTemplateLiteralLoose([""])));

function FixedPromoCode(_ref) {
  var setIsNotEditing = _ref.setIsNotEditing;

  var _useToggle = useToggle(),
      isDialogOpen = _useToggle.value,
      setDialogOpen = _useToggle.setTrue,
      setDialogClosed = _useToggle.setFalse;

  var _useCartContextValue = useCartContextValue(),
      dispatch = _useCartContextValue[1];

  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      user = _useCartNetworkLayerV.user,
      handlePromoCodeDelete = _useCartNetworkLayerV.handlePromoCodeDelete;

  var cart = user.cartV2;
  var savings = cart.promoCodeSavings;
  var promo = getPromoCode(cart) || null;
  var promoCode = promo ? getFormattedPromoCode(promo) : '';

  var handleUpdateEnrollingState = function handleUpdateEnrollingState() {
    dispatch({
      type: TypeKeys.UPDATE_ENROLLING_AS_PC,
      enrollingAsPc: false
    });
  };

  var deletePromoCode = function deletePromoCode() {
    if ((promo === null || promo === void 0 ? void 0 : promo.code) === 'GRAPEFULCLUB') {
      return setDialogOpen();
    }

    return handlePromoCodeDelete(promo, setIsNotEditing, handleUpdateEnrollingState);
  };

  return React__default.createElement(FixedPromoContainer, null, React__default.createElement(RemovePCDialog, {
    isDialogOpen: isDialogOpen,
    setIsNotEditing: setIsNotEditing,
    setDialogClosed: setDialogClosed
  }), React__default.createElement(InputWrapper, null, React__default.createElement(FixedPromoCodeContainer, null, React__default.createElement(FixedPromoCodeText, null, promoCode), React__default.createElement(RemoveIcon, {
    fontSize: 'small',
    onClick: deletePromoCode
  })), React__default.createElement(CheckCircleIcon, null)), React__default.createElement(SavingsText, null, "-$", savings.toFixed(2)));
}

var _templateObject$k, _templateObject2$f, _templateObject3$c, _templateObject4$b, _templateObject5$8, _templateObject6$5;
var cssConstants$g = styles.cssConstants;
var baseStyle = /*#__PURE__*/css(_templateObject$k || (_templateObject$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  font-family: ", ";\n  height: 48px;\n  border-radius: 4px;\n  font-weight: bold;\n  font-size: 11px;\n  line-height: 16px;\n  text-align: center;\n  letter-spacing: 0.08em;\n  font-variant: small-caps;\n"])), cssConstants$g.primaryColor, cssConstants$g.tertiaryFont); // @ts-ignore: Type 'CreateStyled<any>' has no call signatures

var MuiSmallButton = /*#__PURE__*/styled(Button$3)(_templateObject2$f || (_templateObject2$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    ", ";\n    margin-left: 8px;\n    color: ", ";\n    background-color: ", ";\n    :hover {\n      background-color: ", ";\n    }\n  }\n"])), baseStyle, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'white !important' : 'white';
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? cssConstants$g.disabledColor : cssConstants$g.primaryColor;
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? cssConstants$g.disabledColor : cssConstants$g.primaryColor;
});
var Container$3 = /*#__PURE__*/styled.div(_templateObject3$c || (_templateObject3$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  border-top: 1px solid ", ";\n  font-family: ", ";\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 48px;\n"])), cssConstants$g.neutral13, cssConstants$g.tertiaryFont);
var FormContainer = /*#__PURE__*/styled(Form)(_templateObject4$b || (_templateObject4$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 19px;\n"])));
var PromoCodeLabel = /*#__PURE__*/styled.div(_templateObject5$8 || (_templateObject5$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-style: normal;\n  font-weight: bold;\n  font-size: 11px;\n  line-height: 16px;\n  color: ", ";\n  padding: 24px 0 4px 0;\n"])), cssConstants$g.neutral34);
var AddPromoCodeButton = /*#__PURE__*/styled(MuiButton)(_templateObject6$5 || (_templateObject6$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  && {\n    height: 40px !important;\n    font-style: normal;\n    font-weight: bold !important;\n    font-size: 12px !important;\n    line-height: 16px !important;\n    font-family: ", " !important;\n    letter-spacing: 0.08em !important;\n  }\n"])), cssConstants$g.tertiaryFont);
var ValidationSchema = /*#__PURE__*/object().shape({
  promoCode: /*#__PURE__*/string().required('Required')
});
function PromoCodeContainer() {
  var _useCartContextValue = useCartContextValue(),
      isUserPc = _useCartContextValue[0].isUserPc;

  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      user = _useCartNetworkLayerV.user,
      handlePromoCodeUpdate = _useCartNetworkLayerV.handlePromoCodeUpdate;

  var cart = user.cartV2;
  var promo = getPromoCode(cart);
  var promoCode = promo ? getFormattedPromoCode(promo) : '';
  var hasPromo = !!promo;

  var _useToggle = useToggle(hasPromo),
      isEditing = _useToggle.value,
      setIsEditing = _useToggle.setTrue,
      setIsNotEditing = _useToggle.setFalse;

  var _useState = useState(false),
      didMount = _useState[0],
      setDidMount = _useState[1];

  useEffect(function () {
    setDidMount(true);
  }, []);
  useEffect(function () {
    if (didMount) {
      if (hasPromo) {
        setIsEditing();
      } else {
        setIsNotEditing();
      }
    }
  }, [hasPromo]);

  var handleOnSubmit = function handleOnSubmit(values, _ref4) {
    var setErrors = _ref4.setErrors;
    var promoCode = values.promoCode;
    handlePromoCodeUpdate(promoCode, isUserPc, setErrors);
  };

  return React__default.createElement(Container$3, null, !isEditing ? // @ts-ignore
  React__default.createElement(AddPromoCodeButton, {
    onClick: setIsEditing
  }, "ADD A PROMO OR GIFT CODE") : React__default.createElement(Fragment, null, React__default.createElement(PromoCodeLabel, null, "Promo Code"), !hasPromo ? React__default.createElement(Formik, {
    initialValues: {
      promoCode: promoCode
    },
    validateOnChange: true,
    validationSchema: ValidationSchema,
    onSubmit: handleOnSubmit
  }, function (_ref5) {
    var errors = _ref5.errors,
        touched = _ref5.touched,
        values = _ref5.values,
        handleChange = _ref5.handleChange,
        setFieldTouched = _ref5.setFieldTouched;

    var change = function change(name, e) {
      e.persist();
      handleChange(e);
      setFieldTouched(name, true, false);
    };

    var hasErrors = touched.promoCode && Boolean(errors.promoCode);
    return React__default.createElement(FormContainer, null, React__default.createElement(Fragment, null, React__default.createElement(MuiInput, {
      placeholder: 'Enter Promo Code',
      id: 'promoCode',
      name: 'promoCode',
      fullWidth: true,
      validate: true,
      value: values.promoCode && values.promoCode,
      error: hasErrors,
      helperText: touched.promoCode && errors.promoCode,
      hasError: hasErrors,
      // hasSuccess={!Boolean(errors.promoCode)}
      onChange: function onChange(e) {
        return change('promoCode', e);
      }
    }), React__default.createElement(MuiSmallButton, {
      type: 'submit'
    }, "Apply")));
  }) : React__default.createElement(FixedPromoCode, {
    setIsNotEditing: setIsNotEditing
  })));
}

var _templateObject$l, _templateObject2$g, _templateObject3$d, _templateObject4$c, _templateObject5$9, _templateObject6$6, _templateObject7$4;
var cssConstants$h = styles.cssConstants;
var AddToBoxButtonContainer = /*#__PURE__*/styled.div(_templateObject$l || (_templateObject$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding-top: 16px;\n"])));
var MinusIcon = /*#__PURE__*/styled(RemoveIcon$1)(_templateObject2$g || (_templateObject2$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    width: 40px;\n  }\n"])));
var PlusIcon = /*#__PURE__*/styled(AddIcon)(_templateObject3$d || (_templateObject3$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    width: 40px;\n  }\n"])));
var AddToBoxButton = /*#__PURE__*/styled(MuiButton)(_templateObject4$c || (_templateObject4$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    width: 208px;\n    min-width: 208px;\n    border-right: 0 !important;\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n    border-left: 0 !important;\n    border-top-left-radius: 0 !important;\n    border-bottom-left-radius: 0 !important;\n    font-family: ", " !important;\n    @media all and (min-width: 768px) {\n      width: 208px;\n    }\n  }\n"])), cssConstants$h.tertiaryFont);
var MinusIconButton = /*#__PURE__*/styled(MuiButton)(_templateObject5$9 || (_templateObject5$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    min-width: 40px;\n    width: 40px;\n    border-right: 0 !important;\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n    :hover {\n      background: none !important;\n    }\n  }\n"])));
var AddIconButton = /*#__PURE__*/styled(MuiButton)(_templateObject6$6 || (_templateObject6$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    min-width: 40px;\n    width: 40px;\n    border-left: 0 !important;\n    border-top-left-radius: 0 !important;\n    border-bottom-left-radius: 0 !important;\n    :hover {\n      background: none !important;\n    }\n  }\n"])));
var Button$2 = /*#__PURE__*/styled(MuiButton)(_templateObject7$4 || (_templateObject7$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    min-width: 288px;\n  }\n"])));
function AddToBoxButtonWrapper(props) {
  var addButtonEnabled = props.addButtonEnabled,
      isProductEnabled = props.isProductEnabled,
      hidePlusMinus = props.hidePlusMinus;

  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      handleCartAdd = _useCartNetworkLayerV.handleCartAdd,
      handleCartDelete = _useCartNetworkLayerV.handleCartDelete,
      user = _useCartNetworkLayerV.user,
      cartMutationLoading = _useCartNetworkLayerV.cartMutationLoading;

  var _useCartContextValue = useCartContextValue(),
      state = _useCartContextValue[0],
      dispatch = _useCartContextValue[1];

  var pwpProduct = state.pwpProduct,
      cartItems = state.cartItems;
  var cartQty = cartItems && pwpProduct !== null && pwpProduct !== void 0 && pwpProduct.productId ? cartItems[pwpProduct.productId] : 0;
  var dispatchHandleCartAdd = handleCartAddHelper({
    user: user,
    state: state,
    dispatch: dispatch,
    product: pwpProduct,
    handleCartAdd: handleCartAdd,
    cartMutationLoading: cartMutationLoading
  });
  var dispatchHandleCartMinus = handleCartMinusHelper({
    user: user,
    state: state,
    dispatch: dispatch,
    product: pwpProduct,
    handleCartAdd: handleCartAdd,
    handleCartDelete: handleCartDelete,
    cartMutationLoading: cartMutationLoading
  });
  var isInCart = cartQty > 0;
  var buttonText = isInCart ? hidePlusMinus ? "REMOVE" : "CART (" + cartQty + ")" : 'ADD TO CART ';
  return React__default.createElement(AddToBoxButtonContainer, null, hidePlusMinus ? React__default.createElement(Button$2, {
    disabled: !isProductEnabled,
    // @ts-ignore
    type: isInCart ? 'PRIMARY' : 'SECONDARY',
    onClick: isInCart ? dispatchHandleCartMinus : dispatchHandleCartAdd
  }, buttonText) : React__default.createElement("div", null, React__default.createElement(MinusIconButton, {
    disabled: !isProductEnabled,
    // @ts-ignore
    type: 'SECONDARY',
    onClick: dispatchHandleCartMinus
  }, React__default.createElement(MinusIcon, null)), React__default.createElement(AddToBoxButton, {
    disabled: !isProductEnabled,
    // @ts-ignore
    type: cartQty ? 'PRIMARY' : 'SECONDARY',
    onClick: dispatchHandleCartAdd,
    fullWidth: true
  }, buttonText), React__default.createElement(AddIconButton, {
    disabled: !addButtonEnabled,
    // @ts-ignore
    type: 'SECONDARY',
    onClick: dispatchHandleCartAdd
  }, React__default.createElement(PlusIcon, null))));
}

var _templateObject$m, _templateObject2$h, _templateObject3$e, _templateObject4$d, _templateObject5$a, _templateObject6$7, _templateObject7$5, _templateObject8$3, _templateObject9$3, _templateObject10$2, _templateObject11$1, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;
var cssConstants$i = styles.cssConstants;
var StyledDialog = /*#__PURE__*/withStyles({
  root: {
    textAlign: 'center',
    zIndex: "10002 !important"
  },
  paper: {
    maxWidth: '340px'
  },
  paperScrollPaper: {
    maxHeight: '100vh'
  }
})(MuiDialog);
var Content = /*#__PURE__*/styled.div(_templateObject$m || (_templateObject$m = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 16px;\n  font-family: ", ";\n"])), cssConstants$i.tertiaryFont);
var CompleteCase = /*#__PURE__*/styled.div(_templateObject2$h || (_templateObject2$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 256px;\n  height: 36px;\n  margin: auto;\n  font-family: ", ";\n  line-height: 1.64;\n  text-align: center;\n  font-size: 11px;\n  color: black;\n"])), cssConstants$i.tertiaryFont);
var CircleText = /*#__PURE__*/styled.div(_templateObject3$e || (_templateObject3$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 48px;\n  height: 38px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 1.36;\n  text-align: center;\n  color: white;\n  padding-left: 8px;\n  padding-top: 14px;\n"])), cssConstants$i.tertiaryFont);
var CircleContainer = /*#__PURE__*/styled.div(_templateObject4$d || (_templateObject4$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  z-index: 12;\n  height: 64px;\n  position: absolute;\n  top: 0;\n  padding-left: 16px;\n"])));
var ImageContainer = /*#__PURE__*/styled.div(_templateObject5$a || (_templateObject5$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  z-index: 10;\n  position: relative;\n"])));
var OfferText = /*#__PURE__*/styled.div(_templateObject6$7 || (_templateObject6$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-size: 30px;\n  font-weight: bold;\n  line-height: 1.34;\n  letter-spacing: -0.5px;\n  color: black;\n  padding-top: 10px;\n  padding-bottom: 5px;\n  @media all and (min-width: 768px) {\n    padding-top: 16px;\n  }\n"])), cssConstants$i.tertiaryFont);
var ProductName$1 = /*#__PURE__*/styled.div(_templateObject7$5 || (_templateObject7$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-size: 16px;\n  line-height: 1.5;\n  color: black;\n  padding-top: 8px;\n  padding-bottom: 8px;\n"])), cssConstants$i.tertiaryFont);
var SubDescription = /*#__PURE__*/styled.div(_templateObject8$3 || (_templateObject8$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin: auto;\n  font-family: ", ";\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.64;\n  color: #1a1a1a;\n  padding-top: 8px;\n"])), cssConstants$i.tertiaryFont);
var OriginalPrice = /*#__PURE__*/styled.span(_templateObject9$3 || (_templateObject9$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  text-decoration: line-through;\n  height: 24px;\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: black;\n"])), cssConstants$i.tertiaryFont);
var DiscountedPrice = /*#__PURE__*/styled.span(_templateObject10$2 || (_templateObject10$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  height: 24px;\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 1.5;\n  color: black;\n"])), cssConstants$i.tertiaryFont);
var PassText = /*#__PURE__*/styled.div(_templateObject11$1 || (_templateObject11$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 106px;\n  height: 18px;\n  margin: auto;\n  font-family: ", ";\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.64;\n  color: ", ";\n  cursor: pointer;\n  text-align: center;\n  text-decoration: underline;\n  padding-top: 16px;\n  padding-bottom: 10px;\n  @media all and (min-width: 768px) {\n    padding-bottom: 24px;\n  }\n"])), cssConstants$i.tertiaryFont, cssConstants$i.primaryColor);
var BlueCircle = /*#__PURE__*/styled.div(_templateObject12 || (_templateObject12 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background-color: ", ";\n"])), cssConstants$i.linkColor);
var Dialog$4 = /*#__PURE__*/styled(StyledDialog)(_templateObject13 || (_templateObject13 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    z-index: 10002 !important;\n    font-family: ", ";\n  }\n"])), cssConstants$i.tertiaryFont);
var CloseButtonContainer$3 = /*#__PURE__*/styled.div(_templateObject14 || (_templateObject14 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 16px 0 16px;\n"])));
var IconButton$4 = /*#__PURE__*/styled(MuiIconButton)(_templateObject15 || (_templateObject15 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &.MuiIconButton-root {\n    padding: 3px !important;\n    border-radius: 50% !important;\n  }\n  .MuiSvgIcon-root {\n    width: 1.2em;\n    height: 1.2em;\n    color: black;\n  }\n"])));
var ProductImage = /*#__PURE__*/styled.img(_templateObject16 || (_templateObject16 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  height: 240px;\n  width: 240px;\n  @media all and (min-width: 768px) {\n    height: 288px;\n    width: 288px;\n  }\n"])));
function PurchaseWithPurchaseDialog() {
  var fullScreen = useMediaQuery('(max-width:400px)');

  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      user = _useCartNetworkLayerV.user,
      pwpConfig = _useCartNetworkLayerV.pwpConfig,
      showPwpDialog = _useCartNetworkLayerV.showPwpDialog,
      togglePwpDialogClosed = _useCartNetworkLayerV.togglePwpDialogClosed;

  var _useCartNetworkLayerV2 = useCartNetworkLayerValue(),
      assetsUrl = _useCartNetworkLayerV2.assetsUrl;

  var _useCartContextValue = useCartContextValue(),
      _useCartContextValue$ = _useCartContextValue[0],
      pwpProduct = _useCartContextValue$.pwpProduct,
      cartItems = _useCartContextValue$.cartItems;

  var handleClose = function handleClose() {
    togglePwpDialogClosed();
  };

  var handleNoThanks = function handleNoThanks() {
    var accountId = user !== null && user !== void 0 && user.conciergeCustomerAccountId ? user === null || user === void 0 ? void 0 : user.conciergeCustomerAccountId : user === null || user === void 0 ? void 0 : user.userId;
    sessionStorage.setItem(accountId + "hidePwpDialog", 'true');
    handleClose();
  };

  var getSalePrice = function getSalePrice(priceSale) {
    if (!priceSale) return null;
    return Number.isInteger(priceSale) ? "$" + priceSale : Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(priceSale);
  };

  var images = pwpProduct.images,
      price = pwpProduct.price,
      priceSale = pwpProduct.priceSale,
      productId = pwpProduct.productId;
  var productCatalog = images ? images.squareFront : null;
  var imgSrc = "" + assetsUrl + productCatalog;
  var salePrice = getSalePrice(priceSale);
  var pwpConfigItem = getPwpConfigItem(productId, pwpConfig);

  var _getPwpInfo = getPwpInfo(cartItems, productId, pwpConfig),
      addButtonEnabled = _getPwpInfo.addButtonEnabled,
      hidePlusMinus = _getPwpInfo.hidePlusMinus;

  return React__default.createElement(Dialog$4, {
    open: showPwpDialog,
    onClose: handleClose,
    scroll: 'paper',
    disableBackdropClick: true,
    "aria-labelledby": 'alert-dialog-title',
    "aria-describedby": 'alert-dialog-description',
    fullScreen: fullScreen
  }, React__default.createElement(CloseButtonContainer$3, null, React__default.createElement(IconButton$4, {
    "aria-label": 'close',
    onClick: handleClose
  }, React__default.createElement(CloseIcon$1, null))), React__default.createElement(Content, null, React__default.createElement(CompleteCase, null, "Congrats! With the purchase of 6 bottles, you've unlocked this exclusive offer."), React__default.createElement(OfferText, null, "Get this $", price, " ", React__default.createElement("br", null), pwpConfigItem === null || pwpConfigItem === void 0 ? void 0 : pwpConfigItem.mixedPackText, " for ", salePrice, "!"), React__default.createElement("div", null, React__default.createElement(ImageContainer, null, React__default.createElement(ProductImage, {
    alt: 'purchase-with-purchase',
    src: imgSrc
  }), React__default.createElement(CircleContainer, null, React__default.createElement(BlueCircle, null, React__default.createElement(CircleText, null, "$", price, " value"))))), React__default.createElement(ProductName$1, null, pwpConfigItem === null || pwpConfigItem === void 0 ? void 0 : pwpConfigItem.description), React__default.createElement("div", null, React__default.createElement(OriginalPrice, null, "$", price), React__default.createElement(DiscountedPrice, null, "\xA0", salePrice, " + $5 shipping")), (pwpConfigItem === null || pwpConfigItem === void 0 ? void 0 : pwpConfigItem.subDescription) && React__default.createElement(SubDescription, null, pwpConfigItem.subDescription), React__default.createElement(AddToBoxButtonWrapper, {
    isProductEnabled: true,
    addButtonEnabled: addButtonEnabled,
    hidePlusMinus: hidePlusMinus
  }), React__default.createElement(PassText, {
    onClick: handleNoThanks
  }, "No thanks, I'll pass.")));
}

var _templateObject$n;
var neutral5 = styles.cssConstants.neutral5;
var Container$4 = /*#__PURE__*/styled.div(_templateObject$n || (_templateObject$n = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid ", ";\n  border-top: 1px solid ", ";\n  padding: 8px 0;\n"])), neutral5, neutral5);
function DiscountContainer$1() {
  var _useToggle = useToggle(),
      isDialogOpen = _useToggle.value,
      setDialogOpen = _useToggle.setTrue,
      setDialogClosed = _useToggle.setFalse;

  var _useCartContextValue = useCartContextValue(),
      isUserPc = _useCartContextValue[0].isUserPc,
      dispatch = _useCartContextValue[1];

  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      user = _useCartNetworkLayerV.user,
      handlePromoCodeUpdate = _useCartNetworkLayerV.handlePromoCodeUpdate,
      handlePromoCodeDelete = _useCartNetworkLayerV.handlePromoCodeDelete,
      handleApplyRewards = _useCartNetworkLayerV.handleApplyRewards,
      cartPromoCodeUpdateMutationLoading = _useCartNetworkLayerV.cartPromoCodeUpdateMutationLoading,
      applyRewardsToCartMutationLoading = _useCartNetworkLayerV.applyRewardsToCartMutationLoading;

  var handleUpdateEnrollingState = function handleUpdateEnrollingState() {
    dispatch({
      type: TypeKeys.UPDATE_ENROLLING_AS_PC,
      enrollingAsPc: false
    });
  };

  var handlePromoCodeAdd = function handlePromoCodeAdd(promoCode, setErrors, resetForm) {
    handlePromoCodeUpdate(promoCode, isUserPc, setErrors, resetForm);
  };

  var handlePromoCodeRemove = function handlePromoCodeRemove(promo, setErrors) {
    if ((promo === null || promo === void 0 ? void 0 : promo.code) === 'GRAPEFULCLUB') {
      return setDialogOpen();
    }

    return handlePromoCodeDelete(promo, function () {}, handleUpdateEnrollingState, setErrors);
  };

  var handleRewardPointsAdd = function handleRewardPointsAdd(rewardsAmount, setErrors, resetForm) {
    return handleApplyRewards(rewardsAmount, setErrors, resetForm, user, isUserPc);
  };

  return React__default.createElement(Container$4, null, React__default.createElement(RemovePCDialog, {
    isDialogOpen: isDialogOpen,
    setIsNotEditing: function setIsNotEditing() {},
    setDialogClosed: setDialogClosed
  }), React__default.createElement(Discount, {
    user: user,
    cart: user === null || user === void 0 ? void 0 : user.cartV2,
    handlePromoCodeAdd: handlePromoCodeAdd,
    handlePromoCodeRemove: handlePromoCodeRemove,
    handleRewardPointsAdd: handleRewardPointsAdd,
    applyRewardsToCartMutationLoading: applyRewardsToCartMutationLoading,
    cartPromoCodeUpdateMutationLoading: cartPromoCodeUpdateMutationLoading
  }));
}

var _templateObject$o, _templateObject2$i, _templateObject3$f, _templateObject4$e, _templateObject5$b;
var cssConstants$j = styles.cssConstants; // const drawerWidth = 400;
// const useStyles = makeStyles(() =>
//   createStyles({
//     drawer: {
//       zIndex: `10001 !important`
//     },
//     drawerPaper: {
//       width: drawerWidth,
//       zIndex: 10001
//     },
//     drawerPaperMobile: {
//       width: '100%',
//       zIndex: 10001
//     }
//   })
// );

var MuiDrawerComponent = function MuiDrawerComponent(_ref) {
  var rest = _extends({}, _ref);

  return React__default.createElement(Drawer, Object.assign({
    classes: {
      root: 'Cart-MuiDrawer-root',
      paper: 'Cart-MuiDrawer-paper'
    }
  }, rest));
};

var MuiDrawer = /*#__PURE__*/styled(MuiDrawerComponent)(_templateObject$o || (_templateObject$o = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  z-index: 10001 !important;\n  .Cart-MuiDrawer-paper {\n    width: ", ";\n    z-index: 10001;\n  }\n"])), function (p) {
  return p.istablet === 'true' ? "400px" : '100%';
}); // const MuiDrawer = styled(Drawer)``;

var CartContainer = /*#__PURE__*/styled.div(_templateObject2$i || (_templateObject2$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n"])));
var Content$1 = /*#__PURE__*/styled.div(_templateObject3$f || (_templateObject3$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  overflow: auto;\n  min-height: 2em;\n  padding: 16px 24px;\n  flex-direction: column;\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-between;\n"])));
var Footer = /*#__PURE__*/styled.div(_templateObject4$e || (_templateObject4$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  flex-shrink: 0;\n"])));
var CheckoutButton = /*#__PURE__*/styled(MuiButton)(_templateObject5$b || (_templateObject5$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    height: 54px !important;\n    border-radius: 0 !important;\n    font-style: normal;\n    font-weight: 300 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    font-family: ", " !important;\n    letter-spacing: 0.1em !important;\n    background-color: ", ";\n  }\n"])), cssConstants$j.tertiaryFont, function (p) {
  return !p.disabled ? cssConstants$j.primaryColor + " !important" : '#c2c2c2 !important';
});
function CartDrawer() {
  var _cart$entries, _cart$entries2, _cart$entries2$edges;

  var isTablet = useMediaQuery('(min-width:768px)'); // const classes = useStyles();

  var _useState = useState(false),
      didMount = _useState[0],
      setDidMount = _useState[1];

  var _useCartNetworkLayerV = useCartNetworkLayerValue(),
      user = _useCartNetworkLayerV.user,
      cartOpen = _useCartNetworkLayerV.cartOpen,
      toggleCartClosed = _useCartNetworkLayerV.toggleCartClosed,
      flags = _useCartNetworkLayerV.flags,
      hopeCommerceUrl = _useCartNetworkLayerV.hopeCommerceUrl,
      checkoutUrl = _useCartNetworkLayerV.checkoutUrl;

  var _useCartContextValue = useCartContextValue(),
      pwpProduct = _useCartContextValue[0].pwpProduct,
      dispatch = _useCartContextValue[1];

  var accountId = user !== null && user !== void 0 && user.conciergeCustomerAccountId ? user === null || user === void 0 ? void 0 : user.conciergeCustomerAccountId : user === null || user === void 0 ? void 0 : user.userId;
  var hidePwpDialog = !!sessionStorage.getItem(accountId + "hidePwpDialog");
  var cart = user === null || user === void 0 ? void 0 : user.cartV2;
  useEffect(function () {
    setDidMount(true);
    return function () {
      setDidMount(false);
    };
  }, []); // useEffect(() => {
  //     if(didMount && cartOpen){
  //         const cartItems = getCartItems(cart);
  //         const cartHasPCSubscription = hasPCSubscription(cart);
  //         const cartTotalItems = getCartTotal(cartItems);
  //         // const filteredCart = getFilteredCart(cart);
  //         const cartTotalNumberOfItems = cartHasPCSubscription ? Number(cartTotalItems) - 1 : cartTotalItems
  //         dispatch({
  //             type: TypeKeys.UPDATE_CART_ITEMS,
  //             newProps: cartItems,
  //         });
  //         dispatch({
  //             type: TypeKeys.UPDATE_CART_TOTAL_NUMBER_OF_ITEMS,
  //             cartTotalNumberOfItems: Number(cartTotalNumberOfItems),
  //         });
  //         dispatch({
  //            type: TypeKeys.UPDATE_CART_VIA_QUALIFIED_TOTAL,
  //            viaQualifiedCartTotal: cart?.viaQualifiedCartTotal,
  //         });
  //
  //         // dispatch({
  //         //     type: TypeKeys.UPDATE_CART,
  //         //     updatedCart: filteredCart,
  //         // });
  //     }
  // }, [ccartMutationLoading]);

  useEffect(function () {
    if (didMount) {
      dispatch({
        type: TypeKeys.UPDATE_AUTOSHIP_ENABLED,
        autoShipEnabled: !!(cart !== null && cart !== void 0 && cart.autoShipEnabled)
      });
    }
  }, [cart === null || cart === void 0 ? void 0 : cart.autoShipEnabled]);
  useEffect(function () {
    if (didMount) {
      dispatch({
        type: TypeKeys.UPDATE_CART_VIA_QUALIFIED_TOTAL,
        viaQualifiedCartTotal: (cart === null || cart === void 0 ? void 0 : cart.discountQualifiedCartTotal) || 0
      });
    }
  }, [cart === null || cart === void 0 ? void 0 : cart.discountQualifiedCartTotal]);
  useEffect(function () {
    if (didMount) {
      dispatch({
        type: TypeKeys.UPDATE_AUTOSHIP_AT_TOP,
        autoShipAtTop: !!(cart !== null && cart !== void 0 && cart.canSubscribeForAutoShip)
      });
    }
  }, [cartOpen]);
  useEffect(function () {
    if (didMount) {
      var cartItems = getCartItems(cart); // const cartHasPCSubscription = true; //hasPCSubscription(cart);
      // const cartTotalItems =  cart?.totalNumberOfItems // getCartTotal(cartItems);
      // const filteredCart = getFilteredCart(cart);
      //? Number(cartTotalItems) - 1
      //: cartTotalItems;

      dispatch({
        type: TypeKeys.UPDATE_CART_ITEMS,
        newProps: cartItems || {}
      });
      dispatch({
        type: TypeKeys.UPDATE_CART_TOTAL_NUMBER_OF_ITEMS,
        cartTotalNumberOfItems: (cart === null || cart === void 0 ? void 0 : cart.totalNumberOfItems) || 0
      });
      dispatch({
        type: TypeKeys.UPDATE_CART,
        updatedCart: cart
      });
    }
  }, [(_cart$entries = cart.entries) === null || _cart$entries === void 0 ? void 0 : _cart$entries.edges]); // useEffect(() => {
  //   if (didMount) {
  //     const isUserPc = isPreferredCustomer(user);
  //     dispatch({
  //       type: TypeKeys.UPDATE_IS_USER_A_PC,
  //       isUserPc,
  //     });
  //   }
  // }, [
  //   user?.permissions?.oneCommerce?.preferredCustomer?.access,
  //   user?.conciergeUser?.permissions?.oneCommerce?.preferredCustomer?.access,
  // ]);
  // useEffect(() => {
  //   if (didMount) {
  //     dispatch({
  //       type: TypeKeys.UPDATE_ENROLLING_AS_PC,
  //       enrollingAsPc: cart?.enrollingAsPc,
  //     });
  //   }
  // }, [cart?.enrollingAsPc]);

  var handleCheckout = function handleCheckout() {
    toggleCartClosed(); // if (handleGoToCheckout) {
    //   handleGoToCheckout(e);
    // }

    var redirectUrl = hopeCommerceUrl + "/check-out"; // If CheckoutV2 flag is true, go to Checkout 2.0. Else use 1.0

    if (flags && flags.checkoutV2 && checkoutUrl) {
      redirectUrl = checkoutUrl;
    }

    return window.location.href = redirectUrl;
  };

  var cartTotal = (cart === null || cart === void 0 ? void 0 : cart.subTotalPriceOfItemsWithDiscount) || 0; //getCartSubtotal(cart);
  // const hasGatedProduct = false //hasGatedProducts(user);

  var showPwpDialog = !hidePwpDialog && !!pwpProduct;
  var rewardPoints = getRewardsFlag(flags);
  var emptyCart = !!!(cart !== null && cart !== void 0 && (_cart$entries2 = cart.entries) !== null && _cart$entries2 !== void 0 && (_cart$entries2$edges = _cart$entries2.edges) !== null && _cart$entries2$edges !== void 0 && _cart$entries2$edges.length);
  var total = numberWithCommas(cartTotal);
  return React__default.createElement(React__default.Fragment, null, showPwpDialog && React__default.createElement(PurchaseWithPurchaseDialog, null), React__default.createElement(MuiDrawer // classes={{
  //   paper: isTablet ? classes.drawerPaper : classes.drawerPaperMobile,
  //   root: classes.drawer
  // }}
  , {
    // classes={{
    //   paper: isTablet ? classes.drawerPaper : classes.drawerPaperMobile,
    //   root: classes.drawer
    // }}
    disableEnforceFocus: true,
    istablet: isTablet.toString(),
    anchor: "right",
    open: cartOpen,
    onClose: toggleCartClosed
  }, React__default.createElement(CartContainer, null, React__default.createElement(Header, null), React__default.createElement(Content$1, null, React__default.createElement("div", null, React__default.createElement(CartItemsWrapper, null)), React__default.createElement("div", null, rewardPoints ? React__default.createElement(DiscountContainer$1, null) : React__default.createElement(PromoCodeContainer, null))), React__default.createElement(Footer, null, React__default.createElement(CheckoutButton, {
    disabled: emptyCart,
    // @ts-ignore
    type: "BLUE",
    fullWidth: true,
    onClick: handleCheckout
  }, "Checkout ($", total, ")")))));
}

function Cart(_ref) {
  var flags = _ref.flags,
      user = _ref.user,
      pwpConfig = _ref.pwpConfig,
      showPwpDialog = _ref.showPwpDialog,
      productsBulk = _ref.productsBulk,
      assetsUrl = _ref.assetsUrl,
      cartOpen = _ref.cartOpen,
      toggleCartOpen = _ref.toggleCartOpen,
      toggleCartClosed = _ref.toggleCartClosed,
      hopeCommerceUrl = _ref.hopeCommerceUrl,
      checkoutUrl = _ref.checkoutUrl,
      handleGoToCheckout = _ref.handleGoToCheckout,
      handleAddMoreItems = _ref.handleAddMoreItems,
      handleCartAdd = _ref.handleCartAdd,
      handleCartDelete = _ref.handleCartDelete,
      handleGoToPreferred = _ref.handleGoToPreferred,
      togglePwpDialogClosed = _ref.togglePwpDialogClosed,
      handleAutoshipCount = _ref.handleAutoshipCount,
      handlePromoCodeDelete = _ref.handlePromoCodeDelete,
      handlePromoCodeUpdate = _ref.handlePromoCodeUpdate,
      handleApplyRewards = _ref.handleApplyRewards,
      handleCartAutoshipToggle = _ref.handleCartAutoshipToggle,
      handleTogglePcMembership = _ref.handleTogglePcMembership,
      cartMutationLoading = _ref.cartMutationLoading,
      handleGoToProductDetailsPage = _ref.handleGoToProductDetailsPage,
      cartPromoCodeUpdateMutationLoading = _ref.cartPromoCodeUpdateMutationLoading,
      applyRewardsToCartMutationLoading = _ref.applyRewardsToCartMutationLoading,
      seasonalWineClubDateGate = _ref.seasonalWineClubDateGate;
  return createElement(CartNetworkLayer, {
    user: user,
    flags: flags,
    pwpConfig: pwpConfig,
    cartOpen: cartOpen,
    assetsUrl: assetsUrl,
    productsBulk: productsBulk,
    handleCartAdd: handleCartAdd,
    showPwpDialog: showPwpDialog,
    handleCartDelete: handleCartDelete,
    toggleCartOpen: toggleCartOpen,
    toggleCartClosed: toggleCartClosed,
    hopeCommerceUrl: hopeCommerceUrl,
    checkoutUrl: checkoutUrl,
    handleGoToProductDetailsPage: handleGoToProductDetailsPage,
    togglePwpDialogClosed: togglePwpDialogClosed,
    handleAddMoreItems: handleAddMoreItems,
    handleGoToCheckout: handleGoToCheckout,
    handleAutoshipCount: handleAutoshipCount,
    handleGoToPreferred: handleGoToPreferred,
    handlePromoCodeDelete: handlePromoCodeDelete,
    handlePromoCodeUpdate: handlePromoCodeUpdate,
    handleApplyRewards: handleApplyRewards,
    cartMutationLoading: cartMutationLoading,
    handleTogglePcMembership: handleTogglePcMembership,
    handleCartAutoshipToggle: handleCartAutoshipToggle,
    cartPromoCodeUpdateMutationLoading: cartPromoCodeUpdateMutationLoading,
    applyRewardsToCartMutationLoading: applyRewardsToCartMutationLoading,
    seasonalWineClubDateGate: seasonalWineClubDateGate
  }, createElement(CartProvider, {
    user: user,
    productsBulk: productsBulk
  }, createElement(CartDrawer, null)));
}

export { Cart };
//# sourceMappingURL=cart.esm.js.map
